import { InputNumber } from 'primeng/inputnumber';
import {
  SCHOOL_DAYS_PER_WEEK,
  xLunchFactor,
  SIXTH_DAY,
  PERM_EXCLUDED_DAYS_TEXT,
  WARN_EXCLUDED_DAYS_TEXT,
  FIXD_LNCH_SUSP_OTHER_EXCLUDED_DAYS_TEXT,
  FIXD_LNCH_SUSP_OTHER_EXCLUDED_DAYS_PARTTIME_TEXT,
  WARN_EXCLUDED_DAYS_PARTTIME_TEXT,
  LINE_1_TEXT,
  exclusionCategoryTypeEnum,
  LINE_2_TEXT,
  LINE_4_TEXT,
  LINE_3_TEXT
} from './../../../constants/exclusionCategory';
import { pupilModel } from '../../../models/pupil.model';
import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterContentChecked,
  inject
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  AcademicYearTerm,
  exclusionsModel,
  nonSchoolDaysModel,
  studentSchoolHistory
} from '@exclusionmodule/models';
import {
  ApiServiceService,
  MessagingService,
  NotificationService,
  ValidateFormDataService
} from '@oneeducation/app-core';
import {
  EXCLUSION_ENDPOINT,
  STUDENT_ENDPOINT,
  ADMIN_ENDPOINT,
  BASE_ENDPOINT
} from '@shared/properties';
import {
  exclusionCategoryEnum,
  lookupEnum
} from '@exclusionmodule/constants/exclusionCategory';
import { LookupModel, DirtyComponent } from '@shared/models';
import { Subscription } from 'rxjs';
import {
  customDateComparerValidator,
  customDateOffROllValidator,
  customOffsetDateValidator,
  customReInstateDateComparerValidator,
  customWithdrawnDateComparerValidator
} from '@exclusionmodule/validators';
import { exclusionMeeting } from '@exclusionmodule/models/exclusion-meeting.model';
import { holidayTypesEnum } from '@schoolmanagement/constants';
import { Select } from 'primeng/select';
import { DateService } from '@shared/services/date.service';
import { dateFormatEnum } from '@shared/services/date-constants';
import { DateControlValidationsService } from '@shared/services/date-control-validations.service';
import {
  LoaderService,
  AccessibilityService,
  DataLossService
} from '@shared/services';
import { UserRoleService } from '@usermanagement/services';
import { DatePicker } from 'primeng/datepicker';
const err_stud_hist =
  'student not registered at this base when exclusion started';
const err_stud_not_reg = 'Student is not registered with this school';
const err_start_date_before_last_appeal_date =
  'Start date must be on or before last appeal meeting date';
const err_start_date_before_last_meeting_date =
  'Start date must be on or before last meeting date';
const err_stud_already_excluded_api_msg =
  'This Student has already been Permanently excluded from this Base/Site combination.';
const err_stud_already_excluded =
  'The student has already been permanently excluded.';
const err_resinstate_date_after_start_date_api_msg =
  'Reinstated reason date must be on or after start date';
const err_resinstate_date_after_start_date =
  'Start date should be on or before the Reinstated date';
const err_withdrawn_after_start_date_api_msg =
  'Withdrawn reason date must be on or after start date';
const err_withdrawn_after_start_date =
  'Start date should be on or before the Withdrawn date';
@Component({
  selector: 'app-exclusion-overview',
  templateUrl: './exclusion-overview.component.html',
  styleUrls: ['./exclusion-overview.component.scss'],
  standalone: false
})
export class ExclusionOverviewComponent
  implements OnInit, OnDestroy, DirtyComponent, AfterContentChecked
{
  private readonly datePipe = inject(DatePipe);
  private readonly apiService = inject(ApiServiceService);
  private readonly notificationService = inject(NotificationService);
  private readonly validateFormDataService = inject(ValidateFormDataService);
  private readonly messagingService = inject(MessagingService);
  private readonly dataLossService = inject(DataLossService);
  private readonly dateService = inject(DateService);
  private readonly loaderService = inject(LoaderService);
  private readonly dateControlValidationService = inject(
    DateControlValidationsService
  );
  private readonly accessibilityService = inject(AccessibilityService);
  private readonly elementRef = inject(ElementRef);
  private readonly userService = inject(UserRoleService);

  @Input() pupilData: pupilModel;
  @Input() exclusionId: number;
  @Input() schoolId: number;
  @Input() isCreateExclusion: boolean;
  @Input() isOffRollEditingEnabled: boolean;
  @Output() isChildFormValid: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @ViewChild('dropdownCategory') dropdownCategory: Select;
  @ViewChild('dropdownStartTime') dropdownStartTime: Select;
  @ViewChild('dropdownEndTime') dropdownEndTime: Select;
  @ViewChild('senStatusDropdown') senStatusDropdown: Select;
  @ViewChild('reinstateReasonDropdown') reinstateReasonDropdown: Select;
  @ViewChild('withdrawnReasonDropdown') withdrawnReasonDropdown: Select;
  @ViewChild('buttonExclusionDetails') buttonExclusionDetails: ElementRef;
  @ViewChild('calStartDate') calStartDate: DatePicker;
  @ViewChild('calEndDate') calEndDate: DatePicker;
  @ViewChild('offSetExcludedDaysInput') offSetExcludedDaysInput: InputNumber;
  @ViewChild('calEndMonitoringDate') calEndMonitoringDate: DatePicker;
  @ViewChild('calReinstateDate') calReinstateDate: DatePicker;
  @ViewChild('calWithdrawnDate') calWithdrawnDate: DatePicker;
  @ViewChild('calDateOffRoll') calDateOffRoll: DatePicker;
  detailTextLine1: string;
  detailTextLine2: string;
  detailTextLine3: string;
  detailTextLine4: string;
  isChildReinstatedOrWithdrawn: boolean;
  isOrWasText: string;
  isPastIncident: boolean;
  exclusion: exclusionsModel;
  originalExclusion: exclusionsModel;
  existingExclusions: exclusionsModel[];
  isSaveClicked: boolean;
  yearRangeNavigator: string;
  filteredReasonsList: any[];
  categoryList: LookupModel[];
  categoryListAll: LookupModel[];
  baseList: any[];
  reinstateReasonList: any[];
  withdrawnReasonList: any[];
  senStatusList: any[];
  termList: any[];
  timeList: any[] = [
    { description: 'AM', value: 'AM' },
    { description: 'PM', value: 'PM' }
  ];
  exclusionSummaryText: string;
  isEditable: boolean;
  isLoading: boolean;
  isInvalidDate: boolean;
  isInvalidMonitorDateStart: boolean;
  isInvalidMonitorDateEnd: boolean;
  academicYearTermList: AcademicYearTerm[];
  academicYearAndTermBasedOnSelectedStartDate: AcademicYearTerm;
  alertSubscription: Subscription;
  componentDetail = {
    componentName: 'Overview',
    formNameToCheckForDirtyness: 'userFields'
  };
  isMeetingStatusUpheld: boolean;
  userFields = new FormGroup({
    category: new FormControl<string | null>(null, Validators.required),
    primaryReason: new FormControl<string | null>(null),
    additionalReason: new FormControl<string | null>(null),
    startDate: new FormControl<Date | null>(null, [
      Validators.required,
      customDateComparerValidator.bind(this)
    ]),
    startTime: new FormControl<string | null>(null),
    endDate: new FormControl<Date | null>(null),
    endTime: new FormControl<string | null>(null),
    senStageWhenExcluded: new FormControl<string | null>(null),
    inCareWhenExcluded: new FormControl<boolean | null>(null),
    pastoralRecd: new FormControl<boolean | null>(null),
    base: new FormControl<string | null>(null),
    excludedDaysOffset: new FormControl<number | null>(
      null,
      customOffsetDateValidator.bind(this)
    ),
    endMonitorDate: new FormControl<Date | null>(
      null,
      customDateComparerValidator.bind(this)
    ),
    sixthDay: new FormControl<Date | null>({ value: null, disabled: true }),
    lengthToDate: new FormControl<number | null>({
      value: null,
      disabled: true
    }),
    reinstateDate: new FormControl<Date | null>(
      null,
      customReInstateDateComparerValidator
    ),
    reinstateReason: new FormControl<string | null>(null),
    withdrawnDate: new FormControl<Date | null>(
      null,
      customWithdrawnDateComparerValidator
    ),
    withdrawnReason: new FormControl<string | null>(null),
    dateOffRoll: new FormControl<Date | null>(null, customDateOffROllValidator),
    excludedLunchTimes: new FormControl<number | null>({
      value: null,
      disabled: true
    }),
    excludedDays: new FormControl<number | null>(null)
  });

  //boolean fields for visibility of controls
  isCategoryVisible: boolean;
  isStartDateVisible: boolean;
  isStartTimeVisible: boolean;
  isEndDateVisible: boolean;
  isEndTimeVisible: boolean;
  isDateOffRollVisible: boolean;
  isNumberOfLunchtimesVisible: boolean;
  isExcludedDaysOffsetVisible: boolean;
  isExcludedDaysDateVisible: boolean;
  isEndMonitoringDateVisible: boolean;
  isSixthDayVisible: boolean;
  isLengthToDateVisible: boolean;
  isLACVisible: boolean;
  isSenStatusVisible: boolean;
  isPastoralVisible: boolean;
  isReinstateDateVisible: boolean;
  isReinstateReasonVisible: boolean;
  isWithdrawnDateVisible: boolean;
  isWithdrawnReasonVisible: boolean;
  //boolean fields to set validators
  isEndDateRequired: boolean;
  exclusionsHighlightDates: string[];
  nonSchoolDays: nonSchoolDaysModel[];
  studentSchoolHistoryList: studentSchoolHistory[];
  nonSchoolDates: Date[];
  minSchoolHistoryDate: Date;
  maxEndDateForAcademicYear: Date;
  excludedDays = 0;
  excludedDaysLessNonSchoolDays = 0;
  excludedDaysLessOffset = 0;
  excludedDaysPartTime = 0;
  studentDaysPerWeek = 0;
  numberOfLunchtimes = 0;
  numberOfLunchtimesWithLunchFactor = 0;
  isPartTime = false;
  apiRoute: string;
  maxSchoolHistoryDate: Date;
  maxAcademicYearDate: Date;
  dateFormat = 'MM/dd/yyyy';
  readonly dateInputFormat: string = 'dd/MM/yyyy';
  selectedCategoryExternalCode: string;
  isFirstTimeDataBindOnEdit = true;
  meetings: exclusionMeeting[];
  originalEditCategory: LookupModel;
  TRUE_VALUE = 'true';
  exclusionStartDate: Date;
  maxReinstateDate: Date;
  isStartDateOverlapped = false;
  isEndDateOverlapped = false;
  exclusionAcademicYearEndDate: Date;
  maxEndMonitoringDate: Date;
  isSetFocusOnEditExclusionsButton = false;
  enteredEndMonitoringDate: string;

  constructor() {
    //Subscribed to outcome change in meeting section. As meeting outcome changes, update relevant fields here
    this.alertSubscription = this.messagingService
      .getAlert()
      .subscribe((arg) => {
        const alertText = arg.value?.toLowerCase();
        if (alertText === 'reinstate') {
          //When meeting outcome set to reinstated, reinstate fields data filled from there should populate here.
          this.isFirstTimeDataBindOnEdit = true;
          this.ngOnInit();
        } else if (
          alertText === 'upheld' ||
          alertText === 'upheldoutcomemeetingdeleted' ||
          alertText === 'deferred'
        ) {
          this.getMeetings();
          this.updateDateOffRollVisibility();
        }
      });
    this.loaderService.isLoading.subscribe((loading) => {
      this.isLoading = loading;
    });
  }

  ngAfterContentChecked(): void {
    this.setFocusOnEditExclusionDetailsButton();
    this.accessibilityCompliantControlSettings();
    this.setAttributesForAlertBox();
    this.validateDateInputs();
    this.setAccessibleNameForDropdownButtons();
    this.setLandmarkRoleForDropdowns();
    this.setTabindexInScrollableRegionForDropDowns();
    this.removeRoleAttributeForDropDowns();
  }

  // Validate all the date inputs
  private validateDateInputs() {
    // Exclusion start date
    if (
      this.userFields.controls.startDate.value &&
      !this.userFields.controls.startDate.errors
    ) {
      const startDate = this.datePipe.transform(
        this.userFields.controls.startDate.value,
        this.dateInputFormat
      );
      this.validateStartDate(startDate);
    }
    // Exclusion end date
    if (
      this.userFields.controls.endDate.value &&
      !this.userFields.controls.endDate.errors
    ) {
      const endDate = this.datePipe.transform(
        this.userFields.controls.endDate.value,
        this.dateInputFormat
      );
      this.validateEndDate(endDate);
    }
    // End monitoring date
    if (
      this.userFields.controls.endMonitorDate.value &&
      !this.userFields.controls.endMonitorDate.errors
    ) {
      const endMonitoringDate = this.datePipe.transform(
        this.userFields.controls.endMonitorDate.value,
        this.dateInputFormat
      );
      this.validateEndMonitoringDate(endMonitoringDate);
    }
    // Reinstate date
    if (
      this.userFields.controls.reinstateDate.value &&
      !this.userFields.controls.reinstateDate.errors
    ) {
      const reinstateDate = this.datePipe.transform(
        this.userFields.controls.reinstateDate.value,
        this.dateInputFormat
      );
      this.validateReinstateDate(reinstateDate);
    }
    // Withdrawn date
    if (
      this.userFields.controls.withdrawnDate.value &&
      !this.userFields.controls.withdrawnDate.errors
    ) {
      const withdrawnDate = this.datePipe.transform(
        this.userFields.controls.withdrawnDate.value,
        this.dateInputFormat
      );
      this.validateWithdrawnDate(withdrawnDate);
    }
    // Off roll date
    if (
      this.userFields.controls.dateOffRoll.value &&
      !this.userFields.controls.dateOffRoll.errors
    ) {
      const offRollDate = this.datePipe.transform(
        this.userFields.controls.dateOffRoll.value,
        this.dateInputFormat
      );
      this.validateDateOffRoll(offRollDate);
    }
  }

  // Ensures every ARIA button, link and menu item has an accessible name
  private setAccessibleNameForDropdownButtons() {
    if (this.dropdownCategory) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.dropdownCategory,
        'Select exclusion category'
      );
    }

    if (this.dropdownStartTime) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.dropdownStartTime,
        'Select period for exclusion start date'
      );
    }

    if (this.dropdownEndTime) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.dropdownEndTime,
        'Select period for exclusion end date'
      );
    }

    if (this.senStatusDropdown) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.senStatusDropdown,
        'Select sen status on exclusion start date'
      );
    }

    if (this.reinstateReasonDropdown) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.reinstateReasonDropdown,
        'Select reason for reinstatement'
      );
    }

    if (this.withdrawnReasonDropdown) {
      this.accessibilityService.setAccessibleNameForDropdownMenuButton(
        this.withdrawnReasonDropdown,
        'Select reason for withdrawn'
      );
    }
  }

  private setAttributesForAlertBox() {
    if (this.elementRef) {
      this.accessibilityService.setAttributesForAlertBox(this.elementRef);
    }
  }

  // Changes to resolve the accessibility issues
  private accessibilityCompliantControlSettings() {
    // Settings for exclusion start time dropdown
    if (this.dropdownStartTime) {
      const attributeMapStartTime = new Map();
      attributeMapStartTime.set('aria-label', 'Start Time');
      this.accessibilityService.setDropDownLabelAttributes(
        this.dropdownStartTime,
        attributeMapStartTime
      );

      // Set label to dropdown
      const props = new Map<string, string>();
      props.set('title', 'Start time');
      this.accessibilityService.setDropDownItemsAttributes(
        this.dropdownStartTime,
        props
      );

      // Remove aria-expanded attribute
      this.accessibilityService.removeAriaExpandedAttribute(
        this.dropdownStartTime
      );
    }

    // Settings for exclusion end time dropdown
    if (this.dropdownEndTime) {
      const attributeMapEndTime = new Map();
      attributeMapEndTime.set('aria-label', 'End Time');
      this.accessibilityService.setDropDownLabelAttributes(
        this.dropdownEndTime,
        attributeMapEndTime
      );

      // Set label to dropdown
      const props = new Map<string, string>();
      props.set('title', 'End time');
      this.accessibilityService.setDropDownItemsAttributes(
        this.dropdownEndTime,
        props
      );

      // Remove aria-expanded attribute
      this.accessibilityService.removeAriaExpandedAttribute(
        this.dropdownEndTime
      );
    }

    // Set attributes of the reinstate dropdown
    if (this.reinstateReasonDropdown) {
      const props = new Map<string, string>();
      props.set('title', 'Reinstate reasons');
      this.accessibilityService.setDropDownItemsAttributes(
        this.reinstateReasonDropdown,
        props
      );
      // Remove aria-expanded attribute
      this.accessibilityService.removeAriaExpandedAttribute(
        this.reinstateReasonDropdown
      );
    }

    // Set attributes of the withdrawn dropdown
    if (this.withdrawnReasonDropdown) {
      const props = new Map<string, string>();
      props.set('title', 'Withdrawn reasons');
      this.accessibilityService.setDropDownItemsAttributes(
        this.withdrawnReasonDropdown,
        props
      );
      // Remove aria-expanded attribute
      this.accessibilityService.removeAriaExpandedAttribute(
        this.withdrawnReasonDropdown
      );
    }

    // Settings for the Exclusion category dropdown
    if (this.dropdownCategory) {
      const props = new Map<string, string>();
      props.set('title', 'Exclusion categories');
      this.accessibilityService.setDropDownItemsAttributes(
        this.dropdownCategory,
        props
      );
      // Remove aria-expanded attribute
      this.accessibilityService.removeAriaExpandedAttribute(
        this.dropdownCategory
      );

      // set value to aria-activedescendant attribute
      this.accessibilityService.setDropDownAriaActiveDescendant(
        this.dropdownCategory,
        'category'
      );
    }

    // Settings for the exclusion start date calender
    if (this.calStartDate) {
      const props = new Map<string, string>();
      props.set('title', 'Exclusion start date');
      this.accessibilityService.setCalenderButtonAttributes(
        this.calStartDate,
        props
      );
    }

    // Settings for SEN status dropdown
    if (this.senStatusDropdown) {
      const props = new Map<string, string>();
      props.set('title', 'SEN status');
      this.accessibilityService.setDropDownItemsAttributes(
        this.senStatusDropdown,
        props
      );

      // Remove aria-expanded attribute from SEN dropdown
      this.accessibilityService.removeAriaExpandedAttribute(
        this.senStatusDropdown
      );

      // set value to aria-activedescendant attribute
      this.accessibilityService.setDropDownAriaActiveDescendant(
        this.senStatusDropdown,
        'senStageWhenExcluded'
      );
    }

    // Settings for the exclusion end date calender
    if (this.calEndDate) {
      const props = new Map<string, string>();
      props.set('title', 'Exclusion end date');
      this.accessibilityService.setCalenderButtonAttributes(
        this.calEndDate,
        props
      );
    }

    // Settings for the end monitor date calender
    if (this.calEndMonitoringDate) {
      const props = new Map<string, string>();
      props.set('title', 'End monitoring date');
      this.accessibilityService.setCalenderButtonAttributes(
        this.calEndMonitoringDate,
        props
      );
    }

    // Settings for offset excluded days input number
    if (this.offSetExcludedDaysInput) {
      const props = new Map<string, string>();
      props.set('title', 'Offset excluded Days');
      this.accessibilityService.setInputNumberAttributes(
        this.offSetExcludedDaysInput,
        props
      );

      const attrs: string[] = [
        'aria-valuemin',
        'aria-valuemax',
        'aria-valuenow'
      ];
      const propsToRemove = new Map<string, string[]>();
      propsToRemove.set('.p-inputtext', attrs);
      this.accessibilityService.removeControlAttributes(
        this.offSetExcludedDaysInput,
        propsToRemove
      );
    }

    // Settings for reinstate date calender
    if (this.calReinstateDate) {
      const props = new Map<string, string>();
      props.set('title', 'Reinstate date');
      this.accessibilityService.setCalenderButtonAttributes(
        this.calReinstateDate,
        props
      );
    }

    // Settings for withdrawn date calender
    if (this.calWithdrawnDate) {
      const props = new Map<string, string>();
      props.set('title', 'Withdrawn date');
      this.accessibilityService.setCalenderButtonAttributes(
        this.calWithdrawnDate,
        props
      );
    }

    // Settings for date off roll calender
    if (this.calDateOffRoll) {
      const props = new Map<string, string>();
      props.set('title', 'Date off roll');
      this.accessibilityService.setCalenderButtonAttributes(
        this.calDateOffRoll,
        props
      );
    }
  }

  ngOnInit() {
    this.categoryList = [];
    this.exclusionsHighlightDates = [];
    this.nonSchoolDates = [];

    this.populateExclusionCategoryLookup();
    this.populateLookupOptions('0608', 'SenStatus');
    this.populateLookupOptions('0559', 'Terms');

    //edit
    if (!this.isCreateExclusion) {
      this.getMeetings();
      this.getExclusionDetails();
    }

    this.getStudentSchoolHistory();
    this.createYearRange();
    this.getStudentExclusions();
    this.isSetFocusOnEditExclusionsButton = true;
  }

  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
  }

  getMeetings() {
    const apiRoute = EXCLUSION_ENDPOINT.GetExclusionMeetingAppeals.replace(
      '{exclusionId}',
      this.exclusionId?.toString()
    );
    this.apiService.getAll<any[]>(apiRoute, '').subscribe({
      next: (x: any) => {
        this.meetings = x.meetingappeal;
        this.updateDateOffRollVisibility();
      },
      error: (x: any) => {
        if (x.error.statusCode === 404) {
          this.meetings = null;
          this.updateDateOffRollVisibility();
        }
      }
    });
  }

  updateDateOffRollVisibility() {
    const meetingWithUpheldOutcome = this.meetings?.find(
      (x) =>
        x.decisionResult?.toLowerCase() === 'upheld' &&
        x.meetingType?.toLowerCase() === 'governing'
    );
    if (meetingWithUpheldOutcome != null) {
      this.isMeetingStatusUpheld = true;
    } else {
      this.isMeetingStatusUpheld = false;
    }

    if (
      this.isMeetingStatusUpheld &&
      (this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_PERMANENT ||
        this.selectedCategoryExternalCode ===
          exclusionCategoryEnum.EXT_CODE_APPEAL_UPHELD_FROM_PERM)
    ) {
      this.isDateOffRollVisible = true;
    } else {
      if (this.userFields?.controls.dateOffRoll != null) {
        this.userFields.controls.dateOffRoll.reset();
      }
      this.isDateOffRollVisible = false;
    }
  }

  //used to get the stduent school history
  private getStudentSchoolHistory() {
    const apiRoute = this.getSchoolHistoryApiRoute();
    this.apiService.getAll<studentSchoolHistory[]>(apiRoute, '').subscribe({
      next: (x: any) => {
        this.studentSchoolHistoryList = x.studentschoolhistory;
        this.setMinSchoolHistoryDate();
        this.setMaxSchoolHistoryDate();
        this.getNonSchoolDays();
        this.getAcademicYearAndTerms();
      },
      error: () => {
        this.notificationService.showError(
          'Error getting student school history'
        );
      }
    });
  }

  private setMinSchoolHistoryDate() {
    this.minSchoolHistoryDate = new Date(
      Math.min.apply(
        null,
        this.studentSchoolHistoryList?.map(function (x) {
          return new Date(x.startDate);
        })
      )
    );
  }

  private setMaxSchoolHistoryDate() {
    //post school history dates shoud be disabled
    const studhistoryList: studentSchoolHistory[] =
      this.studentSchoolHistoryList?.filter((x) => x.endDate == null);
    if (studhistoryList == null || studhistoryList?.length <= 0) {
      this.maxSchoolHistoryDate = new Date(
        Math.max.apply(
          null,
          this.studentSchoolHistoryList?.map(function (x) {
            return new Date(x.endDate);
          })
        )
      );
    }
  }

  private setDefaultStartEndTime() {
    //default value for start time and end time
    if (
      this.isStartTimeVisible &&
      (this.isCreateExclusion ||
        (this.isEditable && this.userFields.controls.startTime.value == null))
    ) {
      this.userFields.controls.startTime.setValue('AM');
    }
    if (
      this.isEndTimeVisible &&
      (this.isCreateExclusion ||
        (this.isEditable && this.userFields.controls.endTime.value == null))
    ) {
      this.userFields.controls.endTime.setValue('PM');
    }
  }

  //to get the sixth day based on start date
  private getSixthDay() {
    this.userFields.controls.sixthDay.reset();
    if (
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_PERMANENT ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_FIXED ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_SUSPENSION ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP
    ) {
      let startDate = this.userFields.controls.startDate.value;
      if (startDate) {
        startDate = new Date(startDate);
        let count = 1;
        while (count < SIXTH_DAY) {
          startDate.setDate(startDate.getDate() + 1);
          const nonSchoolDay: Date = this.nonSchoolDates?.find(
            (x) => startDate.getTime() == new Date(x).getTime()
          );
          //if non school day does not exist then increase the counter
          if (nonSchoolDay == null) {
            count++;
          }
        }
        //if starttime is PM then increase a day
        if (this.userFields.controls.startTime.value == 'PM') {
          startDate.setDate(startDate.getDate() + 1);
        }
        //sixth day should not be populated and displayed, if number of excluded days less than 6 days for FIXD category
        const endDate = this.userFields.controls.endDate.value;
        if (
          this.selectedCategoryExternalCode ==
            exclusionCategoryEnum.EXT_CODE_PERMANENT ||
          this.selectedCategoryExternalCode ==
            exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM ||
          (endDate &&
            startDate.getTime() <= new Date(endDate).getTime() &&
            SIXTH_DAY - 1 < this.excludedDaysLessOffset)
        ) {
          this.userFields.controls.sixthDay.setValue(startDate);
        }
      }
    }
  }

  // Find min and max dates for reinstate and withdrawn calender
  private setMaxReinstateDate() {
    // Set max reinstate/withdrawn date academic year end date(Max)
    // if categories are 1. Reinstate From Permanent 2. Withdrawn From Permanent
    if (
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_PERM
    ) {
      if (this.userFields.controls.startDate.value) {
        const acadYearLastDate = this.GetAcademicYearEndDate();
        this.maxReinstateDate = new Date(acadYearLastDate);
      } else {
        this.maxReinstateDate = null;
      }
    }
    // Set max reinstate/withdrawn date exclusion end date(Max)
    // if categories are 1. Reinstate From Fixed 2. Withdrawn From Fixed
    // 3. Reinstate From Suspension 4. Withdrawn From Suspension
    else if (
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_FIX ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_SUSP ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH
    ) {
      if (this.userFields.controls.endDate.value) {
        this.maxReinstateDate = new Date(
          this.userFields.controls.endDate.value
        );
      }
    }
  }

  private setMaxEndMonitoringDate() {
    if (
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_PERMANENT ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_PERM ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_APPEAL_UPHELD_FROM_PERM ||
      (this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_WARNING &&
        this.userFields.controls.endDate.value === null)
    ) {
      if (this.userFields.controls.startDate.value) {
        const acadYearLastDate = this.GetAcademicYearEndDate();
        this.maxEndMonitoringDate = new Date(acadYearLastDate);
      } else {
        this.maxEndMonitoringDate = null;
      }
    } else if (
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_FIXED ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_SUSPENSION ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_LUNCHTIME ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_FIX ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_SUSP ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_WARNING ||
      this.selectedCategoryExternalCode === exclusionCategoryEnum.EXT_CODE_OTHER
    ) {
      this.maxEndMonitoringDate = this.userFields.controls.endDate.value;
    }
  }

  // Get the academic year end date for passed date
  private GetAcademicYearEndDate() {
    const acadYear =
      this.academicYearAndTermBasedOnSelectedStartDate?.academicYear;
    const acadYearLastDate = new Date(
      Math.max.apply(
        null,
        this.academicYearTermList
          ?.filter((x) => x.academicYear == acadYear)
          ?.map((x) => new Date(x.endDate))
      )
    );
    return acadYearLastDate;
  }

  private getNonSchoolDays() {
    const apiRoute = this.getNonSchoolDaysApiRoute();
    this.apiService.getAll<nonSchoolDaysModel[]>(apiRoute, '').subscribe({
      next: (x: any) => {
        this.nonSchoolDays = x.nonschooldays;

        if (this.nonSchoolDays != null && this.minSchoolHistoryDate != null) {
          const filterNonSchoolDays: nonSchoolDaysModel[] =
            this.nonSchoolDays.filter(
              (x) =>
                new Date(x.nonSchoolDate).getTime() >=
                  this.minSchoolHistoryDate.getTime() &&
                (x.nonSchoolDayReason.trim() == holidayTypesEnum.HOLIDAY ||
                  x.nonSchoolDayReason.trim() == holidayTypesEnum.STAFF_DAY ||
                  x.nonSchoolDayReason.trim() ==
                    holidayTypesEnum.FORCED_CLOSURE)
            );
          if (filterNonSchoolDays != null) {
            filterNonSchoolDays.forEach((x) => {
              this.nonSchoolDates.push(new Date(x.nonSchoolDate));
            });
          }
        }
      },
      error: () => {
        this.notificationService.showError('Error getting non school days');
      }
    });
  }

  //TODO - This is temp code, it will removed once save logic will be on internal code not on description
  getFullTerm(term: string): string {
    return this.termList
      ?.find((m) => m.internalCode == term)
      ?.description?.trim();
  }

  // Get academic year and term based on the selected start date in the field
  // or exclusion start date(On page load)
  // inputDate: It is optional, at page load pass the start date of exclusion, in edit mode it will null
  //            as it will get start date from startDate input field
  private getAcademicYearAndTermBasedOnSelectedStartDate(inputDate?: any) {
    this.academicYearAndTermBasedOnSelectedStartDate = null;
    const startDate = new Date(
      inputDate == null ? this.userFields.controls.startDate.value : inputDate
    );
    if (this.academicYearTermList != null) {
      this.academicYearAndTermBasedOnSelectedStartDate =
        this.academicYearTermList?.find(
          (x) =>
            new Date(x.startDate).getTime() <= startDate.getTime() &&
            new Date(x.endDate).getTime() >= startDate.getTime()
        );
    }
  }

  private populateExclusionSummaryText() {
    if (this.isCreateExclusion || this.isEditable) {
      const endDate = this.userFields.controls.endDate.value;
      let summaryText: string;
      let calAcademicYear: string;
      let isDisplay = true;
      this.excludedDays = null;

      if (
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_PERMANENT ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_PERM ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_APPEAL_UPHELD_FROM_PERM
      ) {
        summaryText = PERM_EXCLUDED_DAYS_TEXT;
        isDisplay = true;
        this.userFields.controls.lengthToDate.setValue(
          this.excludedDaysPartTime
        );
        this.userFields.controls.excludedDays.setValue(this.excludedDays);
      } else if (
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_FIXED ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_FIX ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_OTHER ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_SUSPENSION ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_SUSP
      ) {
        if (this.isNullOrEmpty(endDate)) {
          isDisplay = false;
        } else {
          this.excludedDays = this.excludedDaysPartTime;
          this.userFields.controls.excludedDays.setValue(this.excludedDays);
          //display warning if child is going to school for less then 5 days
          if (
            this.isPartTime &&
            this.studentDaysPerWeek > 0 &&
            this.studentDaysPerWeek < this.excludedDaysPartTime
          ) {
            summaryText = FIXD_LNCH_SUSP_OTHER_EXCLUDED_DAYS_PARTTIME_TEXT;
          } else {
            summaryText = FIXD_LNCH_SUSP_OTHER_EXCLUDED_DAYS_TEXT;
          }
        }
      } else if (
        this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_WARNING
      ) {
        if (this.isNullOrEmpty(endDate)) {
          this.excludedDays = 1;
        } else {
          this.excludedDays = this.excludedDaysPartTime;
        }
        //display warning if child is going to school for less then 5 days
        if (
          this.isPartTime &&
          this.studentDaysPerWeek > 0 &&
          this.studentDaysPerWeek < this.excludedDaysPartTime
        ) {
          summaryText = WARN_EXCLUDED_DAYS_PARTTIME_TEXT;
        } else {
          summaryText = WARN_EXCLUDED_DAYS_TEXT;
        }
      } else if (
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_LUNCHTIME ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_SUSPENSION
      ) {
        if (this.isNullOrEmpty(endDate)) {
          isDisplay = false;
        } else {
          this.excludedDays = this.numberOfLunchtimes;
          this.userFields.controls.excludedDays.setValue(this.excludedDays);
          //display warning if child is going to school for less then 5 days
          if (this.isPartTime) {
            if (
              this.studentDaysPerWeek > 0 &&
              this.studentDaysPerWeek < this.excludedDays
            ) {
              summaryText = FIXD_LNCH_SUSP_OTHER_EXCLUDED_DAYS_PARTTIME_TEXT;
            } else {
              summaryText = FIXD_LNCH_SUSP_OTHER_EXCLUDED_DAYS_TEXT;
            }
            this.userFields.controls.excludedLunchTimes.setValue(
              this.excludedDaysPartTime
            );
          } else {
            summaryText = FIXD_LNCH_SUSP_OTHER_EXCLUDED_DAYS_TEXT;
            this.userFields.controls.excludedLunchTimes.setValue(
              this.excludedDaysLessNonSchoolDays
            );
          }
        }
      }
      if (this.academicYearAndTermBasedOnSelectedStartDate != null) {
        const academicYear: number = Number.parseInt(
          this.academicYearAndTermBasedOnSelectedStartDate.academicYear
        );
        calAcademicYear = academicYear + '-' + (academicYear + 1);
      }

      if (isDisplay && summaryText) {
        this.exclusionSummaryText = summaryText
          .split('[childname]')
          .join(this.getPupilFirstName())
          .replace('[excludeddays]', this.excludedDays?.toString())
          .replace('[year]', calAcademicYear)
          .replace(
            '[termname]',
            this.getFullTerm(
              this.academicYearAndTermBasedOnSelectedStartDate?.academicTerm
            )
          )
          .replace('[basename]', this.pupilData.base)
          .replace('[schooldaysperweek]', SCHOOL_DAYS_PER_WEEK.toString());

        //this is for edit
        if (this.isEditable) {
          this.exclusionSummaryText = this.exclusionSummaryText.replace(
            'will be',
            'has been'
          );
        }
      }
    }
  }

  getStudentExclusions() {
    const apiRoute = EXCLUSION_ENDPOINT.GetExclusionsByStudent.replace(
      '{schoolId}',
      this.schoolId?.toString()
    ).replace('{studentId}', this.pupilData.studentId?.toString());
    this.apiService.getAll<exclusionsModel[]>(apiRoute, '').subscribe({
      next: (x: any) => {
        this.existingExclusions = x.exclusion;
      },
      error: (x: any) => {
        if (!(x.status == 404 && x.statusText == 'Not Found')) {
          this.notificationService.showError('Error getting exclusions');
        }
      }
    });
  }

  checkIfDateNonSchoolDay(calendarDate: Date): boolean {
    if (
      this.nonSchoolDates?.find((x) => x.getTime() == calendarDate.getTime())
    ) {
      return true;
    }
    return false;
  }

  checkIfDateAlreadyInHighlightDateArray(calendarDate: Date): boolean {
    if (
      this.exclusionsHighlightDates?.indexOf(calendarDate.toDateString()) >= 0
    ) {
      return true;
    }

    return false;
  }

  pushToHighlightDateArray(calendarDate: Date) {
    if (this.exclusionsHighlightDates?.indexOf(calendarDate.toDateString()) < 0)
      this.exclusionsHighlightDates.push(calendarDate.toDateString());
  }

  //function to check if new/edit exclusion start or end date is overlapping permanent exclusion
  checkIfPermanentExclusionOverlapped(dateToCompare: Date): boolean {
    const permExclusion: exclusionsModel[] = this.existingExclusions?.filter(
      (x) =>
        x.categoryExtCode === exclusionCategoryEnum.EXT_CODE_PERMANENT &&
        new Date(dateToCompare).getTime() >= new Date(x.startDate).getTime() &&
        x.exclusionId != this.exclusionId
    );
    if (permExclusion?.length > 0) {
      return true;
    }
    return false;
  }

  // Check if start date is a non school date
  isStartDateIsNonSchoolDate(): boolean {
    let isNonSchoolDate = false;
    if (this.calStartDate && this.userFields.controls.startDate.value) {
      const startDate =
        this.calStartDate.el.nativeElement.querySelector('input').value;

      const startDateFormatted = this.dateService.GetDateFromString(
        startDate,
        dateFormatEnum.ddmmyyyy
      );

      isNonSchoolDate = this.dateControlValidationService.isNonSchoolDate(
        startDateFormatted,
        this.nonSchoolDates
      );
    }

    return isNonSchoolDate;
  }

  checkDateForExclusion(value: any): boolean {
    if (this.existingExclusions != null) {
      const calendarDate = new Date(value.year, value.month, value.day);
      if (!this.checkIfDateNonSchoolDay(calendarDate)) {
        this.exclusionsHighlightDates = [];
        this.existingExclusions?.forEach((x) => {
          let endDate: Date;
          const startDate: Date = new Date(x.startDate);

          const extCode = this.getExtCodeFromDescription(x.category);
          //Permanent Exclusion - Highlight all the days from start date of exclusion till end of Academic year
          if (
            extCode == exclusionCategoryEnum.EXT_CODE_PERMANENT ||
            extCode == exclusionCategoryEnum.EXT_CODE_APPEAL_UPHELD_FROM_PERM
          ) {
            // Set maximum academic year date as end date in case of permanent exclusions
            if (this.maxAcademicYearDate) {
              endDate = new Date(this.maxAcademicYearDate);
            }
          } else if (x.reinstatedWithdrawnReasonDate != null) {
            endDate = new Date(x.reinstatedWithdrawnReasonDate);
            //Highlight all days from exclusion start date to -1 day of reinstated or withdrawn date
            endDate.setDate(endDate.getDate() - 1);
          } else if (x.endDate != null) {
            endDate = new Date(x.endDate);
          }

          if (
            (startDate <= calendarDate &&
              !this.isNullOrEmpty(endDate) &&
              calendarDate <= endDate) ||
            (this.isNullOrEmpty(endDate) &&
              startDate.toDateString() == calendarDate.toDateString())
          ) {
            this.pushToHighlightDateArray(calendarDate);
          }
          //}
        });

        if (this.checkIfDateAlreadyInHighlightDateArray(calendarDate)) {
          return true;
        }
      }
    }
    return false;
  }

  private getExcludedDaysLessOffset() {
    const offset = this.userFields.controls.excludedDaysOffset.value;

    this.excludedDaysLessOffset = this.excludedDaysLessNonSchoolDays;

    //less offset
    if (offset > 0) {
      this.excludedDaysLessOffset = this.excludedDaysLessNonSchoolDays - offset;
    }
  }
  private getEndDate(): any {
    let endDate;
    //The excluded days is calculated using the resintated date as the 'end date'
    if (
      (this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED ||
        this.selectedCategoryExternalCode ==
          exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP) &&
      this.userFields.controls.reinstateDate.value
    ) {
      endDate = this.userFields.controls.reinstateDate.value;
    } else {
      endDate = this.userFields.controls.endDate.value;
    }

    return endDate;
  }

  //method is used to get the days excluded
  getExcludedDays() {
    const startDate = this.userFields.controls.startDate.value;
    let endDate = this.getEndDate();
    let excludedBetweenDays;
    let cntNonSchoolDays = 0;
    this.excludedDaysLessNonSchoolDays = 0;

    if (
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_PERMANENT ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_APPEAL_UPHELD_FROM_PERM
    ) {
      endDate = new Date(new Date().toDateString());
    }
    //Both startDate and endDate must be present to calculate excluded days
    if (startDate && endDate) {
      cntNonSchoolDays = this.getNonSchoolDaysCount(
        new Date(startDate),
        new Date(endDate)
      );
      excludedBetweenDays = this.getDateDifference(startDate, endDate);
      if (excludedBetweenDays < 0) {
        return;
      }
      this.excludedDaysLessNonSchoolDays =
        excludedBetweenDays - cntNonSchoolDays;
      // If start time or end time is visible then only consider for excludedDaysLessNonSchoolDays calculation
      if (
        this.isStartTimeVisible &&
        this.userFields.controls.startTime.value == 'PM'
      )
        this.excludedDaysLessNonSchoolDays =
          this.excludedDaysLessNonSchoolDays - 0.5;

      if (
        this.isEndTimeVisible &&
        this.userFields.controls.endTime.value == 'AM'
      )
        this.excludedDaysLessNonSchoolDays =
          this.excludedDaysLessNonSchoolDays - 0.5;
    }
  }

  private getExcludedDaysBasedOnPartFullTime() {
    this.excludedDaysPartTime = this.excludedDaysLessOffset;
    const startDate = this.userFields.controls.startDate.value;
    const endDate = this.getEndDate();

    if (startDate && endDate) {
      this.isStudentPartTime(new Date(startDate), new Date(endDate));
      if (this.isPartTime) {
        if (
          this.studentDaysPerWeek > 0 &&
          this.studentDaysPerWeek < this.excludedDaysLessOffset
        ) {
          const startDateWeekNumber = this.getWeekNumber(startDate);
          const endDateWeekNumber = this.getWeekNumber(endDate);
          this.excludedDaysPartTime =
            (endDateWeekNumber - startDateWeekNumber + 1) *
            this.studentDaysPerWeek;
        }
      }
    }
  }

  private isStudentPartTime(startDate: Date, endDate: Date) {
    this.isPartTime = false;
    const schoolHistory: studentSchoolHistory =
      this.studentSchoolHistoryList?.find(
        (x) =>
          new Date(x.startDate).getTime() <= startDate.getTime() &&
          (new Date(x.endDate).getTime() >= endDate.getTime() ||
            x.endDate == null)
      );
    if (schoolHistory != null) {
      this.studentDaysPerWeek = schoolHistory.daysPerWeek;
      if (schoolHistory.daysPerWeek < SCHOOL_DAYS_PER_WEEK) {
        this.isPartTime = true;
      }
    }
  }

  //get number of lunch times
  private getNumberOfLunchtimes() {
    this.numberOfLunchtimes = this.numberOfLunchtimesWithLunchFactor = 0;

    //lunchtime is required ony for lunchtime exclusion
    if (
      this.selectedCategoryExternalCode ==
      exclusionCategoryEnum.EXT_CODE_LUNCHTIME
    ) {
      if (this.isPartTime && this.excludedDaysPartTime > 0) {
        this.numberOfLunchtimes =
          this.excludedDaysPartTime * xLunchFactor.DEFAULT;
      } else if (this.excludedDaysLessNonSchoolDays > 0) {
        this.numberOfLunchtimes =
          this.excludedDaysLessNonSchoolDays * xLunchFactor.DEFAULT;
      }
      this.numberOfLunchtimesWithLunchFactor = this.numberOfLunchtimes;
      //less offset
      const offset: number = this.userFields.controls.excludedDaysOffset.value;
      if (offset > 0 && this.numberOfLunchtimes > 0) {
        this.numberOfLunchtimes = this.numberOfLunchtimes - offset;

        this.excludedDaysLessNonSchoolDays =
          this.excludedDaysLessNonSchoolDays - offset * 2;
      }
    }
  }

  private getWeekNumber(selectedDate: Date): number {
    const oneJan: Date = new Date(selectedDate.getFullYear(), 0, 1);
    const numberOfDays = this.getDateDifference(oneJan, selectedDate);
    const weekNumber = Math.ceil((oneJan.getDay() + 1 + numberOfDays) / 7);
    return weekNumber;
  }

  //to get the count of non school days in between the start date and end date
  getNonSchoolDaysCount(startDate: Date, endDate: Date): number {
    let cntNonSchoolDays = 0;
    if (this.nonSchoolDates != null) {
      for (
        let date: Date = startDate;
        date.getTime() <= endDate.getTime();
        date.setDate(date.getDate() + 1)
      ) {
        const nonSchoolDay: Date = this.nonSchoolDates?.find(
          (x) => date.getTime() == new Date(x).getTime()
        );
        //if non school day exist then increase the counter
        if (nonSchoolDay != null) {
          cntNonSchoolDays++;
        }
      }
    }
    return cntNonSchoolDays;
  }

  //get the number of days between 2 dates
  private getDateDifference(startDate: any, endDate: any): number {
    const sDate: Date = new Date(startDate);
    const eDate: Date = new Date(endDate);
    return Math.floor(
      (Date.UTC(eDate.getFullYear(), eDate.getMonth(), eDate.getDate()) -
        Date.UTC(sDate.getFullYear(), sDate.getMonth(), sDate.getDate())) /
        (1000 * 3600 * 24) +
        1
    ); //Diference in Days
  }

  // Get all academic year and term for the base
  private getAcademicYearAndTerms() {
    const apiRoute = BASE_ENDPOINT.GetTermAndAcademicYear.replace(
      '{schoolId}',
      this.schoolId?.toString()
    );

    this.apiService.get<AcademicYearTerm>(apiRoute, '').subscribe({
      next: (x: any) => {
        this.academicYearTermList = x.academicyearterm;
        this.setMaxAcademicYearDate();
      },
      error: () => {
        this.notificationService.showError(
          'Error getting academic year and terms'
        );
      }
    });
  }

  // Set max academic year end date
  private setMaxAcademicYearDate() {
    // In case of create exclusion, to set the maximum academic year date pass Today's date
    if (this.isCreateExclusion) {
      this.getAcademicYearAndTermBasedOnSelectedStartDate(
        new Date().toDateString()
      );
    } // In update, while academic year end date is not present, get the date based on current exclusion start date
    else if (this.academicYearAndTermBasedOnSelectedStartDate == null) {
      this.getAcademicYearAndTermBasedOnSelectedStartDate(
        this.exclusion?.startDate
      );
    }
    this.maxAcademicYearDate = new Date(
      Math.max.apply(
        null,
        this.academicYearTermList
          ?.filter(
            (x) =>
              x.academicYear ==
              this.academicYearAndTermBasedOnSelectedStartDate?.academicYear
          )
          .map(function (x) {
            return new Date(x.endDate);
          })
      )
    );
    //StartDate and EndDate validation - Enable dates till the academic year defined
    if (
      this.maxSchoolHistoryDate == null ||
      this.maxSchoolHistoryDate.getTime() > this.maxAcademicYearDate.getTime()
    ) {
      this.maxSchoolHistoryDate = this.maxAcademicYearDate;
    }
  }

  get f() {
    return this.userFields.controls;
  }

  //reset all user fields except category drop down
  private resetUserFieldsExceptCategory() {
    this.userFields.controls.primaryReason.reset();
    this.userFields.controls.additionalReason.reset();
    this.userFields.controls.startDate.reset();
    this.userFields.controls.startTime.reset();
    this.userFields.controls.endDate.reset();
    this.userFields.controls.endTime.reset();
    this.userFields.controls.senStageWhenExcluded.reset();
    this.userFields.controls.inCareWhenExcluded.reset();
    this.userFields.controls.pastoralRecd.reset();
    this.userFields.controls.base.reset();
    this.userFields.controls.excludedDaysOffset.reset();
    this.userFields.controls.endMonitorDate.reset();
    this.userFields.controls.sixthDay.reset();
    this.userFields.controls.lengthToDate.reset();
    this.userFields.controls.reinstateDate.reset();
    this.userFields.controls.reinstateReason.reset();
    this.userFields.controls.withdrawnDate.reset();
    this.userFields.controls.withdrawnReason.reset();
    this.userFields.controls.dateOffRoll.reset();
    this.userFields.controls.excludedLunchTimes.reset();
    this.userFields.controls.excludedDays.reset();
  }

  changeCategory(category) {
    this.showSpinner(true);
    //give time to load all the data that is coming from API
    setTimeout(() => {
      this.resetControlVisibility();
      if (this.isCreateExclusion) {
        this.resetUserFieldsExceptCategory();
      }
      this.userFields.get('category').setValue(category);
      this.selectedCategoryExternalCode =
        this.getExclusionCategoryExternalCode(category);
      this.populateControls();
      if (this.isEditable) {
        if (this.isFirstTimeDataBindOnEdit) {
          this.setUserFields();
          this.isFirstTimeDataBindOnEdit = false;
        }
        this.checkDateValidation(null);
      }

      this.setRequiredFieldValidator();
      this.setDefaultStartEndTime();
      this.setMaxReinstateDate();
      this.setMaxEndMonitoringDate();
      this.isLACVisible =
        this.isSenStatusVisible =
        this.isPastoralVisible =
          true;
      this.showSpinner(false);
    }, 1500);
  }

  onCategoryChange(category) {
    this.changeCategory(category);
    this.dataLossService.addComponentToCheckUnsavedChanges(this);
  }

  private populateControls() {
    switch (this.selectedCategoryExternalCode) {
      case exclusionCategoryEnum.EXT_CODE_FIXED:
      case exclusionCategoryEnum.EXT_CODE_SUSPENSION:
        this.populateFIXDorSUSPCategoryControls();
        break;
      case exclusionCategoryEnum.EXT_CODE_PERMANENT:
      case exclusionCategoryEnum.EXT_CODE_APPEAL_UPHELD_FROM_PERM:
        this.populatePERMorAPERCategoryControls();
        break;
      case exclusionCategoryEnum.EXT_CODE_LUNCHTIME:
        this.populateLNCHCategoryControls();
        break;
      case exclusionCategoryEnum.EXT_CODE_WARNING:
        this.populateWARNCategoryControls();
        break;
      case exclusionCategoryEnum.EXT_CODE_OTHER:
        this.populateOTHERCategoryControls();
        break;
      case exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED:
      case exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP:
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_FIX:
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_SUSP:
        this.populateFIXDorSUSPCategoryControls();
        this.populateReinstateAndWithdrawnCategoryControls();
        break;
      case exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM:
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_PERM:
        this.populatePERMorAPERCategoryControls();
        this.populateReinstateAndWithdrawnCategoryControls();
        break;
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH:
        this.populateLNCHCategoryControls();
        this.populateReinstateAndWithdrawnCategoryControls();
        this.isStartTimeVisible = this.isEndTimeVisible = true;
        break;
      default:
    }
  }

  private populateReinstateAndWithdrawnCategoryControls() {
    this.userFields.controls.withdrawnDate.clearValidators();
    this.userFields.controls.withdrawnReason.clearValidators();
    this.userFields.controls.dateOffRoll.reset();
    this.isReinstateDateVisible =
      this.isReinstateReasonVisible =
      this.isWithdrawnDateVisible =
      this.isWithdrawnReasonVisible =
        false;

    switch (this.selectedCategoryExternalCode) {
      case exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED:
      case exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP:
      case exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM:
        this.isReinstateDateVisible = this.isReinstateReasonVisible = true;
        this.userFields.controls.withdrawnDate.reset();
        this.userFields.controls.withdrawnReason.reset();
        this.populateLookupOptions('0462', 'ReinstateReason');
        break;
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_PERM:
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH:
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_FIX:
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_SUSP:
        this.isSixthDayVisible = false;
        this.userFields.controls.sixthDay.reset();
        this.userFields.controls.reinstateDate.reset();
        this.userFields.controls.reinstateReason.reset();
        this.isWithdrawnDateVisible = this.isWithdrawnReasonVisible = true;
        this.userFields.controls.withdrawnDate.setValidators([
          Validators.required,
          customWithdrawnDateComparerValidator
        ]);
        this.userFields.controls.withdrawnReason.setValidators(
          Validators.required
        );
        this.populateLookupOptions('0462', 'WithdrawnReason');
        break;
    }
    this.userFields.controls.withdrawnDate.updateValueAndValidity();
    this.userFields.controls.withdrawnReason.updateValueAndValidity();
  }

  private populateFIXDorSUSPCategoryControls() {
    this.isStartDateVisible =
      this.isStartTimeVisible =
      this.isEndDateVisible =
      this.isEndTimeVisible =
      this.isExcludedDaysOffsetVisible =
      this.isEndMonitoringDateVisible =
      this.isSixthDayVisible =
        true;

    this.isEndDateRequired = true;

    if (this.isEditable) {
      this.userFields.controls.lengthToDate.reset();
      this.userFields.controls.excludedLunchTimes.reset();
      this.userFields.controls.dateOffRoll.reset();
    }
  }

  private populateOTHERCategoryControls() {
    this.isStartDateVisible =
      this.isStartTimeVisible =
      this.isEndDateVisible =
      this.isEndTimeVisible =
      this.isExcludedDaysOffsetVisible =
      this.isEndMonitoringDateVisible =
        true;

    this.isEndDateRequired = true;

    if (this.isEditable) {
      this.userFields.controls.sixthDay.reset();
      this.userFields.controls.lengthToDate.reset();
      this.userFields.controls.dateOffRoll.reset();
      this.userFields.controls.excludedLunchTimes.reset();
    }
  }

  private populatePERMorAPERCategoryControls() {
    this.isStartDateVisible =
      this.isStartTimeVisible =
      this.isEndMonitoringDateVisible =
      this.isLengthToDateVisible =
        true;
    if (
      this.userFields.controls.category.value !=
      exclusionCategoryEnum.EXT_CODE_APPEAL_UPHELD_FROM_PERM
    ) {
      this.isSixthDayVisible = true;
    }

    this.updateDateOffRollVisibility();

    if (this.isEditable) {
      this.userFields.controls.endDate.reset();
      this.userFields.controls.endTime.reset();
      this.userFields.controls.excludedDaysOffset.reset();
      this.userFields.controls.excludedLunchTimes.reset();
      this.userFields.controls.excludedDays.reset();
    }
  }

  private populateLNCHCategoryControls() {
    this.isStartDateVisible =
      this.isEndDateVisible =
      this.isNumberOfLunchtimesVisible =
      this.isExcludedDaysOffsetVisible =
      this.isEndMonitoringDateVisible =
        true;

    this.isEndDateRequired = true;

    if (this.isEditable) {
      this.userFields.controls.startTime.reset();
      this.userFields.controls.sixthDay.reset();
      this.userFields.controls.lengthToDate.reset();
      this.userFields.controls.dateOffRoll.reset();
    }
  }

  private populateWARNCategoryControls() {
    this.isStartDateVisible =
      this.isStartTimeVisible =
      this.isEndDateVisible =
      this.isEndTimeVisible =
      this.isEndMonitoringDateVisible =
        true;

    if (this.isEditable) {
      this.userFields.controls.excludedDaysOffset.reset();
      this.userFields.controls.sixthDay.reset();
      this.userFields.controls.lengthToDate.reset();
      this.userFields.controls.dateOffRoll.reset();
      this.userFields.controls.excludedLunchTimes.reset();
      this.userFields.controls.excludedDays.reset();
    }
  }

  private setRequiredFieldValidator() {
    const endDateControl = this.userFields.get('endDate');
    if (this.isEndDateRequired) {
      endDateControl.setValidators([
        Validators.required,
        customDateComparerValidator.bind(this),
        customReInstateDateComparerValidator.bind(this)
      ]);
    } else {
      endDateControl.setValidators([
        customDateComparerValidator.bind(this),
        customReInstateDateComparerValidator.bind(this)
      ]);
    }
    endDateControl.updateValueAndValidity();
  }

  private isCategoryOfTypeCreate(categoryExtCode): boolean {
    return (
      categoryExtCode == exclusionCategoryEnum.EXT_CODE_WARNING ||
      categoryExtCode == exclusionCategoryEnum.EXT_CODE_FIXED ||
      categoryExtCode == exclusionCategoryEnum.EXT_CODE_PERMANENT ||
      categoryExtCode == exclusionCategoryEnum.EXT_CODE_LUNCHTIME ||
      categoryExtCode == exclusionCategoryEnum.EXT_CODE_OTHER ||
      categoryExtCode == exclusionCategoryEnum.EXT_CODE_SUSPENSION
    );
  }

  private getExclusionCategoryExternalCode(intCode: string): string {
    let externalCode: string;
    const lookupItem = this.categoryListAll?.find(
      (x) => x.internalCode == intCode
    );
    if (lookupItem) {
      externalCode = lookupItem.externalCode;
    }
    return externalCode;
  }

  private getExclusionCategoryInternalCode(description: string): string {
    let internalCode: string;
    const lookupItem = this.categoryListAll?.find(
      (x) => x.description.toLowerCase() == description.toLowerCase()
    );
    if (lookupItem) {
      internalCode = lookupItem.internalCode;
    }
    return internalCode;
  }

  private populateExclusionCategory() {
    const activeCategoryList: LookupModel[] = this.categoryListAll?.filter(
      (x) => new String(x.active).toLowerCase() == this.TRUE_VALUE
    );

    if (this.isCreateExclusion) {
      for (const lookup of activeCategoryList) {
        if (this.isCategoryOfTypeCreate(lookup.externalCode)) {
          this.categoryList.push(lookup);
        }
      }
      setTimeout(() => {
        if (this.dropdownCategory) {
          this.dropdownCategory.focus();
        }
      }, 0);
    } else {
      for (const lookup of activeCategoryList) {
        this.categoryList.push(lookup);
      }
      this.sortCategoryList();
    }
  }

  private sortCategoryList() {
    this.categoryList.sort((a, b) => (a.description < b.description ? -1 : 1));
  }

  private resetControlVisibility() {
    this.isCategoryVisible =
      this.isStartDateVisible =
      this.isStartTimeVisible =
      this.isEndDateVisible =
      this.isEndTimeVisible =
      this.isNumberOfLunchtimesVisible =
      this.isExcludedDaysOffsetVisible =
      this.isDateOffRollVisible =
      this.isExcludedDaysDateVisible =
      this.isEndMonitoringDateVisible =
      this.isSixthDayVisible =
      this.isLengthToDateVisible =
      this.isLACVisible =
      this.isSenStatusVisible =
      this.isPastoralVisible =
      this.isReinstateDateVisible =
      this.isReinstateReasonVisible =
      this.isWithdrawnDateVisible =
      this.isWithdrawnReasonVisible =
        false;

    this.isEndDateRequired = false;

    this.userFields.get('category').clearValidators();
    this.userFields.get('endDate').clearValidators();
    this.userFields.get('excludedLunchTimes').clearValidators();
    this.userFields.get('withdrawnDate').clearValidators();
    this.userFields.get('withdrawnReason').clearValidators();

    this.exclusionSummaryText = null;
  }

  //Get lookup API route
  private getLookupApiRoute(lookupTableId: string, isActive: boolean) {
    let apiRoute = ADMIN_ENDPOINT.GetLookups.replace(
      '{tableId}',
      lookupTableId
    );
    if (isActive) {
      apiRoute = apiRoute + '?active=True';
    }
    return apiRoute;
  }

  private populateExclusionCategoryLookup() {
    const apiRoute = this.getLookupApiRoute(
      lookupEnum.EXCLUSION_CATEGORY,
      false
    );
    this.apiService.getAll<any[]>(apiRoute, '').subscribe({
      next: (x: any) => {
        this.categoryListAll = x.lookups;
        this.populateExclusionCategory();
      },
      error: () => {
        this.notificationService.showError('Error getting the lookup options');
      }
    });
  }
  // Populate the lookup options
  private populateLookupOptions(lookupTableId: string, table: string): any {
    // Check if the data is already binded
    // If not then bind the data
    let isDataBindingRequired = false;
    switch (table) {
      case 'ReinstateReason':
        isDataBindingRequired = !this.reinstateReasonList;
        break;
      case 'WithdrawnReason':
        isDataBindingRequired = !this.withdrawnReasonList;
        break;
      case 'SenStatus':
        isDataBindingRequired = !this.senStatusList;
        break;
      case 'Terms':
        isDataBindingRequired = !this.termList;
        break;
    }

    if (isDataBindingRequired) {
      const apiRoute = this.getLookupApiRoute(lookupTableId, true);
      this.apiService.getAll<any[]>(apiRoute, '').subscribe({
        next: (x: any) => {
          // Assign lookup data to the related lookup type
          this.assignLookUpData(table, x.lookups);
        },
        error: () => {
          this.notificationService.showError(
            'Error getting the lookup options'
          );
        }
      });
    }
  }

  // This method is to set the relevant data to the relavant lookup type
  private assignLookUpData(lookupType: string, lookupData: any[]) {
    switch (lookupType) {
      case 'ReinstateReason':
        this.reinstateReasonList = lookupData;
        break;
      case 'WithdrawnReason':
        this.withdrawnReasonList = lookupData;
        break;
      case 'SenStatus':
        this.senStatusList = lookupData;
        break;
      case 'Terms':
        this.termList = lookupData;
        break;
    }
  }

  //Get the exclusion on edit that is going to update
  private getExclusionDetails() {
    this.apiService
      .getAll<
        exclusionsModel[]
      >(EXCLUSION_ENDPOINT.GetExclusion.replace('{exclusionId}', this.exclusionId?.toString()), '')
      .subscribe({
        next: (x: any) => {
          this.exclusion = null;
          this.exclusion = x.exclusion;
          this.originalExclusion = x.exclusion;
          this.exclusionStartDate = new Date(x.exclusion.startDate);
          this.checkIfInactiveCategoryPush();
          this.setDataInEditOrTextMode();
          this.messagingService.sendAlert(this.exclusion.categoryExtCode);
        },
        error: () => {
          this.notificationService.showError(
            'Something went wrong, please try again.'
          );
        }
      });
  }

  //Check if inactive category need to push
  private checkIfInactiveCategoryPush() {
    if (this.exclusion != null) {
      const intCode = this.getExclusionCategoryInternalCode(
        this.exclusion.category
      );
      this.originalEditCategory = this.categoryListAll?.find(
        (x) => x.internalCode === intCode
      );
      if (
        this.originalEditCategory != null &&
        new String(this.originalEditCategory.active).toLowerCase() !=
          this.TRUE_VALUE
      ) {
        this.categoryList.push(this.originalEditCategory);
        this.sortCategoryList();
      }
    }
  }

  //Check if inactive category need to pop
  private checkIfInactiveCategoryPop() {
    if (
      this.originalEditCategory != null &&
      this.originalEditCategory.description != this.exclusion.category &&
      new String(this.originalEditCategory.active).toLowerCase() !=
        this.TRUE_VALUE
    ) {
      this.categoryList = this.categoryList.filter(
        (x) => x.internalCode !== this.originalEditCategory.internalCode
      );
    }
  }

  private getPupilFirstName(): string {
    return this.pupilData.studentName.substr(
      0,
      this.pupilData.studentName.indexOf(' ')
    );
  }

  private bindSummaryText() {
    this.isPastIncident = this.getIsPastIncident(this.exclusion.endDate);

    const pupilFirstName = this.getPupilFirstName();

    this.detailTextLine1 = this.formatAndBindTextForLine1(pupilFirstName);

    this.detailTextLine2 = this.formatAndBindTextForLine2();

    this.detailTextLine3 = this.formatAndBindTextForLine3(pupilFirstName);

    this.detailTextLine4 = this.formatAndBindTextForLine4(pupilFirstName);
  }

  private formatAndBindTextForLine1(pupilFirstname: string): string {
    let result: string;
    const category = this.getCategoryType(true);
    const excludedDays: [number, number] = this.getExcludedDaysForLine1();
    const noOfExcludedDays = excludedDays[0];
    const noOfLunchtimes = excludedDays[1];

    if (category === exclusionCategoryTypeEnum.WARNING) {
      result = this.getLine1TextForExcludedDays(
        noOfExcludedDays,
        LINE_1_TEXT.WARNING_EXCLUDED_DAYS,
        LINE_1_TEXT.WARNING
      );
    } else if (this.isPastIncident) {
      result = this.getPastIncidentTextForLine1(
        category,
        noOfLunchtimes,
        noOfExcludedDays
      );
    } else {
      result = this.getPresentIncidentTextForLine1(
        category,
        noOfLunchtimes,
        noOfExcludedDays
      );
    }

    result = this.replaceText(
      result,
      ['[childname]', '[excludeddays]', '[nooflunchtime]', '[basename]'],
      [pupilFirstname, noOfExcludedDays, noOfLunchtimes, this.pupilData.base]
    );

    return result;
  }

  private getPastIncidentTextForLine1(
    category: string,
    noOfLunchtime: number,
    noOfExcludedDays: number
  ): string {
    let result = '';
    if (category === exclusionCategoryTypeEnum.SUSPENDED && noOfLunchtime > 0) {
      result = LINE_1_TEXT.WAS_SUSPENDED_LUNCHTIME_EXCLUDED_DAYS;
    } else if (category === exclusionCategoryTypeEnum.SUSPENDED) {
      result = this.getLine1TextForExcludedDays(
        noOfExcludedDays,
        LINE_1_TEXT.WAS_SUSPENDED_EXCLUDED_DAYS,
        LINE_1_TEXT.WAS_SUSPENDED
      );
    } else if (category === exclusionCategoryTypeEnum.EXCLUDED) {
      result = this.getLine1TextForExcludedDays(
        noOfExcludedDays,
        LINE_1_TEXT.WAS_EXCLUDED_EXCLUDED_DAYS,
        LINE_1_TEXT.WAS_EXCLUDED
      );
    }

    return result;
  }

  private getPresentIncidentTextForLine1(
    category: string,
    noOfLunchtime: number,
    noOfExcludedDays: number
  ): string {
    let result = '';

    if (category === exclusionCategoryTypeEnum.SUSPENDED && noOfLunchtime > 0) {
      result = LINE_1_TEXT.IS_SUSPENDED_LUNCHTIME_EXCLUDED_DAYS;
    } else if (category === exclusionCategoryTypeEnum.SUSPENDED) {
      result = this.getLine1TextForExcludedDays(
        noOfExcludedDays,
        LINE_1_TEXT.IS_SUSPENDED_EXCLUDED_DAYS,
        LINE_1_TEXT.IS_SUSPENDED
      );
    } else if (category === exclusionCategoryTypeEnum.EXCLUDED) {
      result = this.getLine1TextForExcludedDays(
        noOfExcludedDays,
        LINE_1_TEXT.IS_EXCLUDED_EXCLUDED_DAYS,
        LINE_1_TEXT.IS_EXCLUDED
      );
    }

    return result;
  }

  private getIsPastIncident(endDate: Date) {
    const formattedEndDate = this.isNullOrEmpty(endDate)
      ? null
      : new Date(endDate).getTime();
    const formattedTodaysDate = new Date().getTime();
    return this.isNullOrEmpty(formattedEndDate)
      ? false
      : formattedEndDate >= formattedTodaysDate
        ? false
        : true;
  }

  private getLine1TextForExcludedDays(
    excludedNoOfDays: number,
    textWithExcludedDays: string,
    textWithoutExcludedDays: string
  ): string {
    return excludedNoOfDays > 0
      ? textWithExcludedDays
      : textWithoutExcludedDays;
  }

  private replaceText(
    text: string,
    textToReplace: any[],
    textToReplaceWith: any[]
  ): string {
    if (textToReplace.length === textToReplaceWith.length) {
      let index = 0;
      textToReplace.forEach((x) => {
        if (text && text.includes(x)) {
          text = text.replace(x, textToReplaceWith[index]);
        }

        index = index + 1;
      });
    }

    return text;
  }

  private formatAndBindTextForLine2() {
    const startDate = this.getFormattedDateToShow(this.exclusion.startDate);
    const endDate = this.getFormattedDateToShow(this.exclusion.endDate);
    const categoryText = this.getCategoryType(false);
    let result: string;

    if (this.isPastIncident) {
      if (categoryText === exclusionCategoryTypeEnum.SUSPENSION) {
        result = this.getLine2Text(
          endDate,
          LINE_2_TEXT.WAS_SUSPENSION_END_DATE,
          LINE_2_TEXT.WAS_SUSPENSION
        );
      } else if (categoryText === exclusionCategoryTypeEnum.EXPULSION) {
        result = this.getLine2Text(
          endDate,
          LINE_2_TEXT.WAS_EXPULSION_END_DATE,
          LINE_2_TEXT.WAS_EXPULSION
        );
      } else if (categoryText === exclusionCategoryTypeEnum.WARNING) {
        result = this.getLine2Text(
          endDate,
          LINE_2_TEXT.WAS_WARNING_END_DATE,
          LINE_2_TEXT.WAS_WARNING
        );
      }
    } else {
      //isPastIncident = False;
      if (categoryText === exclusionCategoryTypeEnum.SUSPENSION) {
        result = this.getLine2Text(
          endDate,
          LINE_2_TEXT.IS_SUSPENSION_END_DATE,
          LINE_2_TEXT.IS_SUSPENSION
        );
      } else if (categoryText === exclusionCategoryTypeEnum.EXPULSION) {
        result = this.getLine2Text(
          endDate,
          LINE_2_TEXT.IS_EXPULSION_END_DATE,
          LINE_2_TEXT.IS_EXPULSION
        );
      } else if (categoryText === exclusionCategoryTypeEnum.WARNING) {
        result = this.getLine2Text(
          endDate,
          LINE_2_TEXT.IS_WARNING_END_DATE,
          LINE_2_TEXT.IS_WARNING
        );
      }
    }

    result = this.replaceText(
      result,
      ['[startdate]', '[enddate]'],
      [startDate, endDate]
    );

    return result;
  }

  private getLine2Text(
    endDate: string,
    textWithEndDate: string,
    textWithoutEndDate: string
  ): string {
    return !this.isNullOrEmpty(endDate) ? textWithEndDate : textWithoutEndDate;
  }

  private formatAndBindTextForLine3(pupilFirstname: string): string {
    let result = '';

    const isLac: boolean = this.getIsLac(this.exclusion.inCareWhenExcluded);
    const hadSenStatus = this.getSendStatus();
    const isSendPlanName = this.getIsSendPlanNamePresent(
      this.exclusion.senStageWhenExcluded
    );
    const hadPastoralSupport = this.getHadPastoralSupport(
      this.exclusion.pastoralRecd
    );
    const isEthinicity = this.getIsEthinicity(this.exclusion.ethnicity);
    const category = this.getCategoryType(false);

    result = this.getLine3Text(
      category,
      isLac,
      hadSenStatus,
      isSendPlanName,
      hadPastoralSupport,
      isEthinicity
    );

    result = this.replaceText(
      result,
      ['[childname]', '[sendstatusplanname]', '[ethinicity]'],
      [
        pupilFirstname,
        this.exclusion.senStageWhenExcluded,
        this.exclusion.ethnicity
      ]
    );

    return result;
  }

  private getLine3Text(
    category: string,
    isLac: boolean,
    hadSenStatus: boolean,
    isSendPlanName: boolean,
    hadPastoralSupport: boolean,
    isEthinicity: boolean
  ): string {
    let result = '';

    // SUSPENSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL_ETHINICITY
    if (
      !isLac &&
      !hadSenStatus &&
      !isSendPlanName &&
      !hadPastoralSupport &&
      isEthinicity
    ) {
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL_ETHINICITY
      );
    } else if (
      isLac &&
      !hadSenStatus &&
      !isSendPlanName &&
      !hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL_ETHINICITY
      );
    } else if (
      !isLac &&
      hadSenStatus &&
      !isSendPlanName &&
      !hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL_ETHINICITY
      );
    } else if (
      isLac &&
      hadSenStatus &&
      !isSendPlanName &&
      !hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL_ETHINICITY
      );
    } else if (
      !isLac &&
      !hadSenStatus &&
      !isSendPlanName &&
      hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL_ETHINICITY
      );
    } else if (
      isLac &&
      !hadSenStatus &&
      !isSendPlanName &&
      hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL_ETHINICITY
      );
    } else if (
      !isLac &&
      hadSenStatus &&
      !isSendPlanName &&
      hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_SEND_STATUS_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_SEND_STATUS_PASTORAL_ETHINICITY
      );
    } else if (
      isLac &&
      hadSenStatus &&
      !isSendPlanName &&
      hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_SEND_STATUS_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_SEND_STATUS_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_SEND_STATUS_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_SEND_STATUS_PASTORAL_ETHINICITY
      );
    } else if (
      !isLac &&
      hadSenStatus &&
      isSendPlanName &&
      !hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL_ETHINICITY
      );
    } else if (
      isLac &&
      hadSenStatus &&
      isSendPlanName &&
      !hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL_ETHINICITY
      );
    } else if (
      !isLac &&
      hadSenStatus &&
      isSendPlanName &&
      hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL_ETHINICITY
      );
    } else if (
      isLac &&
      hadSenStatus &&
      isSendPlanName &&
      hadPastoralSupport &&
      isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL_ETHINICITY
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL_ETHINICITY,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL_ETHINICITY,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL_ETHINICITY
      );
    } else if (
      !isLac &&
      !hadSenStatus &&
      !isSendPlanName &&
      !hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL
      );
    } else if (
      isLac &&
      !hadSenStatus &&
      !isSendPlanName &&
      !hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_NOT_SEND_STATUS_NOT_PASTORAL
      );
    } else if (
      !isLac &&
      hadSenStatus &&
      !isSendPlanName &&
      !hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL
      );
    } else if (
      isLac &&
      hadSenStatus &&
      !isSendPlanName &&
      !hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_SEND_STATUS_NOT_PASTORAL
      );
    } else if (
      !isLac &&
      !hadSenStatus &&
      !isSendPlanName &&
      hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL
      );
    } else if (
      isLac &&
      !hadSenStatus &&
      !isSendPlanName &&
      hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_NOT_SEND_STATUS_PASTORAL
      );
    } else if (
      !isLac &&
      hadSenStatus &&
      !isSendPlanName &&
      hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_PASTORAL,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_SEND_STATUS_PASTORAL,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_SEND_STATUS_PASTORAL
      );
    } else if (
      isLac &&
      hadSenStatus &&
      !isSendPlanName &&
      hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_SEND_STATUS_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_SEND_STATUS_PASTORAL,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_SEND_STATUS_PASTORAL,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_SEND_STATUS_PASTORAL
      );
    } else if (
      !isLac &&
      hadSenStatus &&
      isSendPlanName &&
      !hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL
      );
    } else if (
      isLac &&
      hadSenStatus &&
      isSendPlanName &&
      !hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_NOT_PASTORAL
      );
    } else if (
      !isLac &&
      hadSenStatus &&
      isSendPlanName &&
      hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL,
        LINE_3_TEXT.WARNING_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL,
        LINE_3_TEXT.EXPULSION_NOT_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL
      );
    } else if (
      isLac &&
      hadSenStatus &&
      isSendPlanName &&
      hadPastoralSupport &&
      !isEthinicity
    ) {
      // SUSPENSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL
      result = this.getLine3TextByCategory(
        category,
        LINE_3_TEXT.SUSPENSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL,
        LINE_3_TEXT.WARNING_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL,
        LINE_3_TEXT.EXPULSION_LOOKED_AFTER_SEND_STATUS_SEND_PLAN_NAME_PASTORAL
      );
    }

    return result;
  }

  private getLine3TextByCategory(
    category: string,
    suspensionText: string,
    warningText: string,
    expulsionText: string
  ): string {
    return category == exclusionCategoryTypeEnum.SUSPENSION ||
      category == exclusionCategoryTypeEnum.OTHER
      ? suspensionText
      : category == exclusionCategoryTypeEnum.WARNING
        ? warningText
        : expulsionText;
  }

  private getIsLac(inCareWhenExcluded: any): boolean {
    return !this.isNullOrEmpty(inCareWhenExcluded) &&
      new String(inCareWhenExcluded).toLowerCase() == this.TRUE_VALUE
      ? true
      : false;
  }

  private formatAndBindTextForLine4(pupilFirstName: string): string {
    let result = '';

    this.isChildReinstatedOrWithdrawn = this.isReinstatedOrWithdrawn();
    if (this.isChildReinstatedOrWithdrawn) {
      const category = this.getCategoryType(false);
      const reinstateWithdrawnDate = this.exclusion
        .reinstatedWithdrawnReasonDate
        ? this.getFormattedDateToShow(
            this.exclusion.reinstatedWithdrawnReasonDate
          )
        : this.exclusion.reinstatedWithdrawnReasonDate;
      const reinstatedWithdrawnReason =
        this.exclusion.reinstatedWithdrawnReason;

      if (!reinstateWithdrawnDate && !reinstatedWithdrawnReason) {
        result =
          category == exclusionCategoryTypeEnum.SUSPENSION
            ? LINE_4_TEXT.SUSPENSION
            : category == exclusionCategoryTypeEnum.WARNING
              ? LINE_4_TEXT.WARNING
              : LINE_4_TEXT.EXPULSION;
      } else {
        result = this.getLine4Text(
          category,
          reinstateWithdrawnDate,
          reinstatedWithdrawnReason
        );
      }

      result = this.replaceText(
        result,
        ['[childname]', '[reinstatementdate]', '[reinstatementreason]'],
        [pupilFirstName, reinstateWithdrawnDate, reinstatedWithdrawnReason]
      );
    }

    return result;
  }

  private getLine4Text(
    category: string,
    reinstateWithdrawnDate: any,
    reinstatedWithdrawnReason: any
  ) {
    let result = '';

    if (reinstatedWithdrawnReason) {
      const isWithdrawl = this.getIsWithdrawl(this.exclusion.categoryExtCode);

      if (reinstateWithdrawnDate) {
        result = this.getLine4TextForCategoryWithReasonAndDate(
          isWithdrawl,
          category
        );
      } else {
        result = this.getLine4TextWithReason(isWithdrawl, category);
      }
    } else if (reinstateWithdrawnDate) {
      result =
        category == exclusionCategoryTypeEnum.SUSPENSION
          ? LINE_4_TEXT.SUSPENSION_REINSTATEMENT_DATE
          : category == exclusionCategoryTypeEnum.WARNING
            ? LINE_4_TEXT.WARNING_REINSTATEMENT_DATE
            : LINE_4_TEXT.EXPULSION_REINSTATEMENT_DATE;
    }

    return result;
  }

  private getLine4TextWithReason(
    isWithdrawl: boolean,
    category: string
  ): string {
    let result = '';

    if (isWithdrawl) {
      result =
        category == exclusionCategoryTypeEnum.SUSPENSION
          ? LINE_4_TEXT.SUSPENSION_WITHDRAWL_REASON
          : category == exclusionCategoryTypeEnum.WARNING
            ? LINE_4_TEXT.WARNING_WITHDRAWL_REASON
            : LINE_4_TEXT.EXPULSION_WITHDRAWL_REASON;
    } else {
      result =
        category == exclusionCategoryTypeEnum.SUSPENSION
          ? LINE_4_TEXT.SUSPENSION_REINSTATEMENT_REASON
          : category == exclusionCategoryTypeEnum.WARNING
            ? LINE_4_TEXT.WARNING_REINSTATEMENT_REASON
            : LINE_4_TEXT.EXPULSION_REINSTATEMENT_REASON;
    }

    return result;
  }

  private getLine4TextForCategoryWithReasonAndDate(
    isWithdrawl: boolean,
    category: string
  ): string {
    let result = '';

    if (isWithdrawl) {
      result =
        category == exclusionCategoryTypeEnum.SUSPENSION
          ? LINE_4_TEXT.SUSPENSION_WITHDRAWL_DATE_REASON
          : category == exclusionCategoryTypeEnum.WARNING
            ? LINE_4_TEXT.WARNING_WITHDRAWL_DATE_REASON
            : LINE_4_TEXT.EXPULSION_WITHDRAWL_DATE_REASON;
    } else {
      result =
        category == exclusionCategoryTypeEnum.SUSPENSION
          ? LINE_4_TEXT.SUSPENSION_REINSTATEMENT_DATE_REASON
          : category == exclusionCategoryTypeEnum.WARNING
            ? LINE_4_TEXT.WARNING_REINSTATEMENT_DATE_REASON
            : LINE_4_TEXT.EXPULSION_REINSTATEMENT_DATE_REASON;
    }

    return result;
  }

  private isReinstatedOrWithdrawn() {
    const internalCode = this.exclusion.categoryExtCode;
    if (internalCode) {
      if (
        internalCode == exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED ||
        internalCode == exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM ||
        internalCode == exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP ||
        internalCode == exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_FIX ||
        internalCode == exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH ||
        internalCode == exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_PERM ||
        internalCode == exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_SUSP
      ) {
        return true;
      }
    }

    return false;
  }

  private getIsWithdrawl(exclusionCategory: string): boolean {
    let result = false;
    const exclusionCategoryFormatted = exclusionCategory.toUpperCase();
    if (
      exclusionCategoryFormatted ==
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED ||
      exclusionCategoryFormatted ==
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM ||
      exclusionCategoryFormatted ==
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP
    ) {
      result = false;
    } else if (
      exclusionCategoryFormatted ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_FIX ||
      exclusionCategoryFormatted ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH ||
      exclusionCategoryFormatted ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_PERM ||
      exclusionCategoryFormatted ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_SUSP
    ) {
      result = true;
    }

    return result;
  }

  private isNullOrEmpty(text: any) {
    return text == null || text == undefined || text == '';
  }

  private getSendStatus(): boolean {
    return this.isNullOrEmpty(this.exclusion.senStageWhenExcluded)
      ? false
      : true;
  }

  private getHadPastoralSupport(pastoralRecd: any): boolean {
    return (
      !this.isNullOrEmpty(pastoralRecd) &&
      String(pastoralRecd).toLowerCase() == this.TRUE_VALUE
    );
  }

  private getIsEthinicity(ethnicity: any): boolean {
    return this.isNullOrEmpty(ethnicity) ? false : true;
  }

  private getIsSendPlanNamePresent(senStageWhenExcluded: any): boolean {
    return this.isNullOrEmpty(senStageWhenExcluded) ? false : true;
  }

  private getExcludedDaysForLine1(): [number, number] {
    const exclusionAndLunchtimeDays: [number, number] = [0, 0];
    const excludedDays = this.exclusion.excludedDays;
    if (this.isNullOrEmpty(excludedDays)) {
      return exclusionAndLunchtimeDays;
    }

    exclusionAndLunchtimeDays[0] = excludedDays;

    //For lunchtimes, we need to display both.
    if (
      this.exclusion.categoryExtCode ===
        exclusionCategoryEnum.EXT_CODE_LUNCHTIME ||
      this.exclusion.categoryExtCode ===
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH
    ) {
      exclusionAndLunchtimeDays[1] = exclusionAndLunchtimeDays[0]; //Reverse the lunchtime with no of excluded days due API properties
      exclusionAndLunchtimeDays[0] = this.exclusion.excludedLunchTimes;
    }

    return exclusionAndLunchtimeDays;
  }

  private getCategoryType(isPastIncidentForm: boolean) {
    const extCode = this.exclusion.categoryExtCode;
    let exclusionTypeText = '';
    switch (extCode) {
      case exclusionCategoryEnum.EXT_CODE_FIXED:
      case exclusionCategoryEnum.EXT_CODE_SUSPENSION:
      case exclusionCategoryEnum.EXT_CODE_OTHER:
      case exclusionCategoryEnum.EXT_CODE_LUNCHTIME:
      case exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED:
      case exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP:
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_FIX:
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_SUSP:
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH:
        exclusionTypeText = isPastIncidentForm ? 'suspended' : 'suspension';
        break;
      case exclusionCategoryEnum.EXT_CODE_WARNING:
        exclusionTypeText = 'warning';
        break;
      case exclusionCategoryEnum.EXT_CODE_PERMANENT:
      case exclusionCategoryEnum.EXT_CODE_APPEAL_UPHELD_FROM_PERM:
      case exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM:
      case exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_PERM:
        exclusionTypeText = isPastIncidentForm ? 'excluded' : 'expulsion';
        break;
    }

    return exclusionTypeText;
  }

  private getFormattedDateToShow(date: Date) {
    const validDate = this.getFormattedDate(date);
    return this.isNullOrEmpty(validDate)
      ? ''
      : this.datePipe.transform(date, 'd') +
          this.getOrdinalSuffix(parseInt(this.datePipe.transform(date, 'd'))) +
          ' of ' +
          this.datePipe.transform(date, 'MMMM') +
          ' ' +
          this.datePipe.transform(date, 'yyyy');
  }

  private getFormattedDate(date: Date) {
    return this.datePipe.transform(date, 'dd MMMM yyyy');
  }

  private getOrdinalSuffix(day: number) {
    const suffixes = [
      '<sup>th</sup>',
      '<sup>st</sup>',
      '<sup>nd</sup>',
      '<sup>rd</sup>'
    ];

    const relevantDigits = day < 30 ? day % 20 : day % 30;
    return relevantDigits <= 3 ? suffixes[relevantDigits] : suffixes[0];
  }

  //Create Year Range
  createYearRange() {
    //need to display year range in drop down i.e. previous 11 years and next 2 years
    const currentYear = new Date().getFullYear();
    this.yearRangeNavigator = currentYear - 11 + ':' + (currentYear + 2);
  }

  private getSchoolHistoryApiRoute() {
    //https://d001-oneapi-api-uks-apim.azure-api.net/exc/Students/9567665/Schools/10583/SchoolHistory
    return STUDENT_ENDPOINT.GetSchoolHistoryForBase.replace(
      '{studentId}',
      this.pupilData.studentId
    ).replace('{schoolId}', this.schoolId?.toString());
  }

  private getNonSchoolDaysApiRoute() {
    return STUDENT_ENDPOINT.GetNonSchoolDays.replace(
      '{studentId}',
      this.pupilData.studentId
    ).replace('{schoolId}', this.schoolId?.toString());
  }

  getExtCodeFromDescription(description: string): string {
    let extCode: string;

    const category = this.categoryListAll?.find(
      (x) => x.description.toLowerCase() == description.toLowerCase()
    );
    if (category != null) {
      extCode = category.externalCode;
    }
    return extCode;
  }

  //Used to check if date overlappes with existing exclusion
  checkIsDateOverlapped() {
    if (this.existingExclusions) {
      this.isStartDateOverlapped = this.isEndDateOverlapped = false;
      const startDate = this.userFields.controls.startDate.value;
      const endDate = this.userFields.controls.endDate.value;
      Array.from(this.existingExclusions)?.forEach((x) => {
        if (x.exclusionId === this.exclusionId) {
          return;
        }
        const existingStartDate: Date = new Date(x.startDate);
        let existingEndDate: Date;
        if (x.reinstatedWithdrawnReasonDate != null) {
          existingEndDate = new Date(x.reinstatedWithdrawnReasonDate);
          //Exclusion till -1 day of reinstated or withdrawn date
          existingEndDate.setDate(existingEndDate.getDate() - 1);
        } else if (x.endDate != null) {
          existingEndDate = new Date(x.endDate);
        } else {
          existingEndDate = existingStartDate;
        }
        //Validation for start Date
        if (
          this.userFields.controls.startDate.valid &&
          new Date(startDate).getTime() >= existingStartDate.getTime() &&
          new Date(startDate).getTime() <= existingEndDate.getTime() &&
          new Date(startDate).getTime() <= new Date(endDate).getTime()
        ) {
          this.isStartDateOverlapped = true;
        }
        //Validation for end Date
        if (
          this.userFields.controls.endDate.valid &&
          ((new Date(endDate).getTime() >= existingStartDate.getTime() &&
            new Date(endDate).getTime() <= existingEndDate.getTime()) ||
            (startDate &&
              new Date(startDate).getTime() <= existingStartDate.getTime() &&
              new Date(endDate).getTime() >= existingEndDate.getTime())) &&
          new Date(startDate).getTime() <= new Date(endDate).getTime()
        ) {
          this.isEndDateOverlapped = true;
          return;
        }
      });
    }
  }

  checkDateValidation(event) {
    if (event) {
      if (!this.validManualDateEntry(event)) {
        //Reset validation message for "End date overlaps an existing exclusion"
        //For both start date and end date
        this.isStartDateOverlapped = this.isEndDateOverlapped = false;
        return;
      }
    }
    this.validateEndMonitoringDateOnStartAndEndDate();
    this.checkIsDateOverlapped();
    this.getAcademicYearAndTermBasedOnSelectedStartDate();
    this.populateCalculatedFields(null);
    this.setMaxReinstateDate();
    this.setMaxEndMonitoringDate();
    this.exclusionStartDate = this.userFields.controls.startDate.value;
    this.exclusionAcademicYearEndDate = this.GetAcademicYearEndDate();
  }

  // OnInput function for end monitoring date
  checkEndMonitoringDateValidation(event) {
    if (
      this.userFields.controls.endMonitorDate.errors &&
      this.userFields.controls.endMonitorDate.errors['isInvalidMonitorDate']
    ) {
      return false;
    }
    const inputDate = event?.target?.value;
    // Storing the End Monitoring Date in the variable as the latest value of the control
    // will not be available if the control has errors
    this.enteredEndMonitoringDate = inputDate;
    return this.validateEndMonitoringDate(inputDate);
  }

  // Check whether end monitoring date is valid
  private validateEndMonitoringDate(inputDate: string) {
    if (
      !this.dateService.checkEmptyDate(inputDate) ||
      !this.dateControlValidationService.checkDateFormat(
        inputDate,
        dateFormatEnum.ddmmyyyy,
        this.userFields.controls.endMonitorDate
      )
    ) {
      return false;
    }

    const endMonitoringDate = this.dateService.GetDateFromString(
      inputDate,
      dateFormatEnum.ddmmyyyy
    );
    // Set the End Monitoring Date entered in the endMonitorDate field as the value of the control field
    // will become null if the control has errors
    if (
      new Date(endMonitoringDate).getTime() !=
      new Date(this.userFields.controls.endMonitorDate.value).getTime()
    ) {
      this.userFields.controls.endMonitorDate.setValue(endMonitoringDate);
    }
    if (
      !this.dateControlValidationService.checkDateBeforeExclusionStartDate(
        endMonitoringDate,
        this.userFields.controls.startDate.value,
        this.userFields.controls.endMonitorDate
      ) ||
      !this.dateControlValidationService.checkDateAfterExclusionEndDate(
        endMonitoringDate,
        this.userFields.controls.endDate.value,
        this.userFields.controls.endMonitorDate
      ) ||
      !this.dateControlValidationService.checkDateAfterAcademicYearEndDate(
        endMonitoringDate,
        this.maxAcademicYearDate,
        this.userFields.controls.endMonitorDate
      ) ||
      !this.dateControlValidationService.checkNonSchoolDate(
        endMonitoringDate,
        this.nonSchoolDates,
        this.userFields.controls.endMonitorDate
      )
    ) {
      return false;
    }
    return true;
  }

  // OnInput function for withdrawn date
  checkWithdrawnDateValidation(event) {
    const inputDate = event.target.value;
    this.validateWithdrawnDate(inputDate);
  }

  // Check whether withdrawn date is valid
  private validateWithdrawnDate(inputDate: string) {
    if (
      !this.dateService.checkEmptyDate(inputDate) ||
      !this.dateControlValidationService.checkDateFormat(
        inputDate,
        dateFormatEnum.ddmmyyyy,
        this.userFields.controls.withdrawnDate
      )
    ) {
      return;
    }
    const withdrawnDate = this.dateService.GetDateFromString(
      inputDate,
      dateFormatEnum.ddmmyyyy
    );
    if (
      !this.dateControlValidationService.checkDateBeforeExclusionStartDate(
        withdrawnDate,
        this.userFields.controls.startDate.value,
        this.userFields.controls.withdrawnDate
      ) ||
      !this.dateControlValidationService.checkDateAfterExclusionEndDate(
        withdrawnDate,
        this.userFields.controls.endDate.value,
        this.userFields.controls.withdrawnDate
      ) ||
      !this.dateControlValidationService.checkDateAfterAcademicYearEndDate(
        withdrawnDate,
        this.maxAcademicYearDate,
        this.userFields.controls.withdrawnDate
      ) ||
      !this.dateControlValidationService.checkNonSchoolDate(
        withdrawnDate,
        this.nonSchoolDates,
        this.userFields.controls.withdrawnDate
      )
    ) {
      return;
    }
  }

  populateCalculatedFields(event) {
    if (event) {
      if (!this.validManualDateEntry(event)) {
        return;
      }
    }
    //reset fields
    this.userFields.controls.lengthToDate.reset();
    this.userFields.controls.excludedDays.reset();
    this.userFields.controls.excludedLunchTimes.reset();
    this.excludedDays = 0;
    this.excludedDaysLessNonSchoolDays = 0;
    this.excludedDaysLessOffset = 0;
    this.excludedDaysPartTime = 0;
    this.studentDaysPerWeek = 0;
    this.numberOfLunchtimes = 0;
    this.isPartTime = false;
    this.exclusionSummaryText = null;

    this.getExcludedDays();
    this.getExcludedDaysLessOffset();
    this.getExcludedDaysBasedOnPartFullTime();
    this.getNumberOfLunchtimes();
    this.populateExclusionSummaryText();
    this.getSixthDay();
  }

  // Validate the manual date entry
  validManualDateEntry(event) {
    if (event.target?.id === 'reInstateDate') {
      return this.validManualEntryForReinstate(event);
    }
    if (event.target?.id === 'startDate') {
      return this.validManualEntryForStartDate(event);
    } else if (event.target?.id === 'endDate') {
      return this.validManualEntryForEndDate(event);
    } else if (event.target?.id === 'dateOffRoll') {
      return this.validManualEntryForDateOffRoll(event);
    }
    return true;
  }

  // Validate manual date entry for End Date
  private validManualEntryForEndDate(event) {
    const inputDate = event.target.value;
    return this.validateEndDate(inputDate);
  }

  // Check whether end date is valid
  private validateEndDate(inputDate: string) {
    if (!this.dateService.checkEmptyDate(inputDate)) {
      if (this.isEndDateRequired) {
        this.userFields.controls.endDate.setErrors({ required: true });
      }
      this.isEndDateOverlapped = false;
      return false;
    }
    if (
      !this.dateControlValidationService.checkDateFormat(
        inputDate,
        dateFormatEnum.ddmmyyyy,
        this.userFields.controls.endDate
      )
    ) {
      return false;
    }
    const endDate = this.dateService.GetDateFromString(
      inputDate,
      dateFormatEnum.ddmmyyyy
    );
    if (
      !this.dateControlValidationService.checkNonSchoolDate(
        endDate,
        this.nonSchoolDates,
        this.userFields.controls.endDate
      ) ||
      !this.dateControlValidationService.checkDateBeforeExclusionStartDate(
        endDate,
        this.userFields.controls.startDate.value,
        this.userFields.controls.endDate
      )
    ) {
      return false;
    }

    // If the end date entered is exceeding the max date limit set on the calender
    if (
      !this.dateControlValidationService.checkDateAfterMaxDateLimit(
        endDate,
        this.maxSchoolHistoryDate,
        this.userFields.controls.endDate
      )
    ) {
      return false;
    }

    // If the end date entered is exceeding the min date limit set on the calender
    if (
      !this.dateControlValidationService.checkDateBeforeMinDateLimit(
        endDate,
        this.minSchoolHistoryDate,
        this.userFields.controls.endDate
      )
    ) {
      return false;
    }

    // If exclusion is overlapping with Permanent Exclusion
    if (
      this.checkIfPermanentExclusionOverlapped(
        this.userFields.controls.endDate.value
      )
    ) {
      this.isEndDateOverlapped = false;
      this.userFields.controls.endDate.setErrors({
        isOverlappedWithPermExclusion: true
      });
      return false;
    }

    return true;
  }

  // Validate manual date entry for Start Date
  private validManualEntryForStartDate(event) {
    const inputDate = event.target.value;
    return this.validateStartDate(inputDate);
  }

  // Check whether start date is valid
  private validateStartDate(inputDate: string) {
    if (!this.dateService.checkEmptyDate(inputDate)) {
      this.userFields.controls.startDate.setErrors({ required: true });
      this.isStartDateOverlapped = false;
      return false;
    }

    if (
      !this.dateControlValidationService.checkDateFormat(
        inputDate,
        dateFormatEnum.ddmmyyyy,
        this.userFields.controls.startDate
      )
    ) {
      return false;
    }
    const startDate = this.dateService.GetDateFromString(
      inputDate,
      dateFormatEnum.ddmmyyyy
    );
    if (
      !this.dateControlValidationService.checkStartDateAfterExclusionEndDate(
        startDate,
        this.userFields.controls.endDate.value,
        this.userFields.controls.startDate
      )
    ) {
      return false;
    }
    if (
      !this.dateControlValidationService.checkNonSchoolDate(
        startDate,
        this.nonSchoolDates,
        this.userFields.controls.startDate
      )
    ) {
      return false;
    }

    // If the start date entered is exceeding the max date limit set on the calender
    if (
      !this.dateControlValidationService.checkDateAfterMaxDateLimit(
        startDate,
        this.maxSchoolHistoryDate,
        this.userFields.controls.startDate
      )
    ) {
      return false;
    }

    // If the start date entered is exceeding the min date limit set on the calender
    if (
      !this.dateControlValidationService.checkDateBeforeMinDateLimit(
        startDate,
        this.minSchoolHistoryDate,
        this.userFields.controls.startDate
      )
    ) {
      return false;
    }

    if (
      !this.dateControlValidationService.checkStartDateAfterDateOffRoll(
        startDate,
        this.userFields.controls.dateOffRoll.value,
        this.userFields.controls.startDate
      )
    ) {
      return false;
    }

    // If exclusion is overlapping with Permanent Exclusion
    if (
      this.checkIfPermanentExclusionOverlapped(
        this.userFields.controls.startDate.value
      )
    ) {
      this.isStartDateOverlapped = false;
      this.userFields.controls.startDate.setErrors({
        isOverlappedWithPermExclusion: true
      });
      return false;
    }

    return true;
  }

  private validManualEntryForDateOffRoll(event) {
    const inputDate = event.target.value;
    return this.validateDateOffRoll(inputDate);
  }

  // Check whether off roll date is valid
  private validateDateOffRoll(inputDate) {
    // If start date having validation with date off roll then clear it
    if (
      this.userFields.controls.startDate.hasError('isStartDateAfterDateOffRoll')
    ) {
      this.userFields.controls.startDate.setErrors(null);
    }

    this.userFields.controls.dateOffRoll.setErrors(null);
    if (
      !this.dateService.checkEmptyDate(inputDate) ||
      !this.dateControlValidationService.checkDateFormat(
        inputDate,
        dateFormatEnum.ddmmyyyy,
        this.userFields.controls.dateOffRoll
      )
    ) {
      return false;
    }

    const dateOffRoll = this.dateService.GetDateFromString(
      inputDate,
      dateFormatEnum.ddmmyyyy
    );

    if (
      !this.dateControlValidationService.checkDateOffRollBeforeExclusionStartDate(
        dateOffRoll,
        this.userFields.controls.startDate.value,
        this.userFields.controls.dateOffRoll
      ) ||
      !this.dateControlValidationService.checkDateAfterAcademicYearEndDate(
        dateOffRoll,
        this.maxAcademicYearDate,
        this.userFields.controls.dateOffRoll
      ) ||
      !this.dateControlValidationService.checkNonSchoolDate(
        dateOffRoll,
        this.nonSchoolDates,
        this.userFields.controls.dateOffRoll
      )
    ) {
      return false;
    }
    return true;
  }

  // Validate the manual date entry for the reinstate date
  private validManualEntryForReinstate(event) {
    if (
      this.userFields.controls.reinstateDate.errors &&
      (this.userFields.controls.reinstateDate.errors[
        'isInvalidReinstateDateStart'
      ] ||
        this.userFields.controls.reinstateDate.errors[
          'isInvalidReinstateDateEnd'
        ])
    ) {
      return false;
    }
    const inputDate = event.target.value;
    return this.validateReinstateDate(inputDate);
  }

  // Check whether reinstate date is valid
  private validateReinstateDate(inputDate: string) {
    if (
      !this.dateService.checkEmptyDate(inputDate) ||
      !this.dateControlValidationService.checkDateFormat(
        inputDate,
        dateFormatEnum.ddmmyyyy,
        this.userFields.controls.reinstateDate
      )
    ) {
      return false;
    }
    const reinstateDate = this.dateService.GetDateFromString(
      inputDate,
      dateFormatEnum.ddmmyyyy
    );
    if (
      !this.dateControlValidationService.checkDateBeforeExclusionStartDate(
        reinstateDate,
        this.userFields.controls.startDate.value,
        this.userFields.controls.reinstateDate
      ) ||
      !this.dateControlValidationService.checkDateAfterExclusionEndDate(
        reinstateDate,
        this.userFields.controls.endDate.value,
        this.userFields.controls.reinstateDate
      ) ||
      !this.dateControlValidationService.checkDateAfterAcademicYearEndDate(
        reinstateDate,
        this.maxAcademicYearDate,
        this.userFields.controls.reinstateDate
      ) ||
      !this.dateControlValidationService.checkNonSchoolDate(
        reinstateDate,
        this.nonSchoolDates,
        this.userFields.controls.reinstateDate
      )
    ) {
      return false;
    }
    return true;
  }

  //Function is used to save exclusion
  saveExclusion() {
    this.isSetFocusOnEditExclusionsButton = true;
    this.isSaveClicked = true;
    if (!this.userFields.valid) {
      this.validateFormDataService.validateAllFormFields(this.userFields);
      this.isSaveClicked = false;
      return;
    }
    this.clearReinstateAndWithdrawnFields();
    const primaryReason = this.exclusion.primaryReason;
    const reasons = this.exclusion.reasons;
    this.exclusion = this.userFields.value;
    this.exclusion.primaryReason = primaryReason;
    this.exclusion.reasons = reasons;
    // Find the school details of current selected school
    const school = this.userService.User.schools.find(
      (school) => school.schoolId === this.schoolId
    );
    // Set base name for current selected school
    this.exclusion.baseName = school?.schoolName;
    // Set dfe number for current selected school
    this.exclusion.dfeNumber = school?.dfeNumber;

    this.exclusion.categoryExtCode = this.selectedCategoryExternalCode;
    this.exclusion.category = this.getCategoryDescriptionFromIntExtCode(
      this.userFields.controls.category.value,
      this.exclusion.categoryExtCode
    );

    this.exclusion.term = this.getFullTerm(
      this.academicYearAndTermBasedOnSelectedStartDate.academicTerm
    );
    this.exclusion.academicYear = this.getFormattedAcademicYear(
      this.academicYearAndTermBasedOnSelectedStartDate.academicYear
    );

    //reinstatedWithdrawnReason
    const reinstateReason = this.userFields.controls.reinstateReason.value;
    if (!this.isNullOrEmpty(reinstateReason))
      this.exclusion.reinstatedWithdrawnReason = reinstateReason;

    const withdrawnReason = this.userFields.controls.withdrawnReason.value;
    if (!this.isNullOrEmpty(withdrawnReason))
      this.exclusion.reinstatedWithdrawnReason = withdrawnReason;

    this.exclusion = this.getExclusionWithFormattedDates(this.exclusion);
    this.checkIfCategoryLNCH();

    if (this.isEditable) this.updateExclusion();
  }

  //Function is used to update exclusion
  updateExclusion() {
    this.exclusion.studentId = this.pupilData.studentId;
    this.exclusion.baseId = this.schoolId;
    this.apiService
      .put(
        EXCLUSION_ENDPOINT.UpdateExclusion.replace(
          '{exclusionId}',
          this.exclusionId?.toString()
        ),
        this.exclusion
      )
      .subscribe({
        next: () => {
          this.dataLossService.removeComponentFromUnsavedChanges(this);
          this.notificationService.showSuccess(
            'Exclusion updated successfully.'
          );
          this.originalExclusion = this.exclusion;
          this.checkIfInactiveCategoryPop();
          this.updateExclusionStatus();
          // Get fresh student exclusions after successfull update of exclusions
          this.getStudentExclusions();
          this.resetToOriginal();
          this.messagingService.sendAlert(this.exclusion.categoryExtCode);
          //Request to refresh Student Summary page is set.  Alert then caught in Student Summary page.
          this.messagingService.sendAlert('refreshSummary');
        },
        error: (x: any) => {
          this.isSaveClicked = false;
          if (
            x.error.statusCode === 409 &&
            x.error.code === '1.1.409.51' &&
            x.error.message.toUpperCase() === err_stud_hist.toUpperCase()
          ) {
            this.notificationService.showError(err_stud_not_reg);
          } else if (
            x.error.statusCode === 409 &&
            x.error.code === '1.1.409.51' &&
            (x.error.message.toUpperCase() ===
              err_start_date_before_last_appeal_date.toUpperCase() ||
              x.error.message.toUpperCase() ===
                err_start_date_before_last_meeting_date.toUpperCase())
          ) {
            this.notificationService.showError(x.error.message);
          } else if (
            x.error.statusCode === 409 &&
            x.error.code === '1.1.409.51' &&
            x.error.message === err_stud_already_excluded_api_msg
          ) {
            this.notificationService.showError(err_stud_already_excluded);
          } else if (
            x.error.statusCode === 409 &&
            x.error.code === '1.1.409.01' &&
            x.error.errors.filter(
              (x) => x === err_resinstate_date_after_start_date_api_msg
            ).length > 0
          ) {
            this.notificationService.showError(
              err_resinstate_date_after_start_date
            );
          } else if (
            x.error.statusCode === 409 &&
            x.error.code === '1.1.409.01' &&
            x.error.errors.filter(
              (x) => x === err_withdrawn_after_start_date_api_msg
            ).length > 0
          ) {
            this.notificationService.showError(err_withdrawn_after_start_date);
          } else {
            this.notificationService.showError(
              'Something went wrong, please try again.'
            );
          }
        }
      });
  }

  isDateOffRollInPast() {
    return new Date(
      new Date(this.exclusion.dateOffRoll).toDateString()
    ).getTime() < new Date(new Date().toDateString()).getTime()
      ? true
      : false;
  }

  private clearReinstateAndWithdrawnFields() {
    if (!this.isReinstateDateVisible) {
      this.userFields.controls.reinstateDate.reset();
    }
    if (!this.isReinstateReasonVisible) {
      this.userFields.controls.reinstateReason.reset();
    }
    if (!this.isWithdrawnDateVisible) {
      this.userFields.controls.withdrawnDate.reset();
      this.userFields.controls.withdrawnReason.reset();
    }
    if (
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_PERM ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_APPEAL_UPHELD_FROM_PERM
    ) {
      this.userFields.controls.sixthDay.reset();
    } else if (
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_FIX ||
      this.selectedCategoryExternalCode ==
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_SUSP
    ) {
      this.userFields.controls.excludedDays.reset();
      this.userFields.controls.sixthDay.reset();
      this.userFields.controls.excludedDaysOffset.reset();
    } else if (
      this.selectedCategoryExternalCode ==
      exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH
    ) {
      this.userFields.controls.excludedDays.reset();
      this.userFields.controls.excludedLunchTimes.reset();
      this.userFields.controls.excludedDaysOffset.reset();
    }
  }

  private checkIfCategoryLNCH() {
    if (
      this.selectedCategoryExternalCode ==
      exclusionCategoryEnum.EXT_CODE_LUNCHTIME
    ) {
      const numberOfLunchtimes =
        this.userFields.controls.excludedLunchTimes.value;
      const excludedDays = this.userFields.controls.excludedDays.value;

      //The database switches the values
      this.exclusion.excludedDays = numberOfLunchtimes;
      this.exclusion.excludedLunchTimes = excludedDays;
      // Deleted endTime & startTime from the exclusion which is not required.
      this.exclusion.endTime = null;
      this.exclusion.startTime = null;
    }
  }
  getCategoryDescriptionFromIntExtCode(intCode: string, extCode: string) {
    let description: string;
    const lookupItem = this.categoryListAll?.find(
      (x) => x.internalCode == intCode && x.externalCode == extCode
    );
    if (lookupItem) {
      description = lookupItem.description;
    }
    return description;
  }

  getFormattedAcademicYear(academicYear: string): string {
    const calAcademicYear: string =
      academicYear + '/' + (Number.parseInt(academicYear.substr(2)) + 1);
    return calAcademicYear;
  }

  //Convert to local date string
  getExclusionWithFormattedDates(exclusion: exclusionsModel): exclusionsModel {
    //start date
    exclusion.startDate = this.datePipe.transform(
      this.userFields.controls.startDate.value,
      this.dateFormat
    );
    //end date
    const endDate = this.userFields.controls.endDate.value;
    if (!this.isNullOrEmpty(endDate)) {
      exclusion.endDate = this.datePipe.transform(endDate, this.dateFormat);
    } //End Time is not required when end date is not selected
    else {
      exclusion.endTime = null;
    }
    //sixth day
    const sixthDay = this.userFields.controls.sixthDay.value;
    if (!this.isNullOrEmpty(sixthDay)) {
      exclusion.sixthDay = this.datePipe.transform(sixthDay, this.dateFormat);
    }
    //date off role
    const dateOffRoll = this.userFields.controls.dateOffRoll.value;
    if (!this.isNullOrEmpty(dateOffRoll)) {
      exclusion.dateOffRoll = this.datePipe.transform(
        dateOffRoll,
        this.dateFormat
      );
    }
    //end Monitor Date
    const endMonitorDate = this.userFields.controls.endMonitorDate.value;
    if (!this.isNullOrEmpty(endMonitorDate)) {
      exclusion.endMonitorDate = this.datePipe.transform(
        endMonitorDate,
        this.dateFormat
      );
    }
    //withdrawn date
    const withdrawnDate = this.userFields.controls.withdrawnDate.value;
    if (!this.isNullOrEmpty(withdrawnDate)) {
      exclusion.reinstatedWithdrawnReasonDate = this.datePipe.transform(
        withdrawnDate,
        this.dateFormat
      );
    }
    //reinstate date
    const reinstateDate = this.userFields.controls.reinstateDate.value;
    if (!this.isNullOrEmpty(reinstateDate)) {
      exclusion.reinstatedWithdrawnReasonDate = this.datePipe.transform(
        reinstateDate,
        this.dateFormat
      );
    }

    return exclusion;
  }

  toggleEditing() {
    this.isSetFocusOnEditExclusionsButton = true;

    if (this.dataLossService.checkForUnsavedChanges(this)) {
      this.exclusion = this.originalExclusion;
      this.resetToOriginal();
    }
  }

  showSpinner(value) {
    this.loaderService.isLoading.next(value);
  }

  resetToOriginal() {
    this.isSaveClicked = false;
    this.isEditable = !this.isEditable;
    this.isInvalidDate = false;
    // reset the variable to empty when cancel is pressed
    this.enteredEndMonitoringDate = '';

    this.setDataInEditOrTextMode();
  }

  setDataInEditOrTextMode() {
    if (this.isEditable) {
      this.populateData();
      setTimeout(() => {
        if (this.dropdownCategory) {
          this.dropdownCategory.focus();
        }
      }, 0);
    } else {
      this.isFirstTimeDataBindOnEdit = true;
      this.userFields.reset();
      this.bindSummaryText();
    }
  }

  populateData() {
    this.changeCategory(
      this.getExclusionCategoryInternalCode(this.exclusion.category)
    );

    setTimeout(() => {
      this.userFields.valueChanges.subscribe(() => {
        this.dataLossService.addComponentToCheckUnsavedChanges(this);
      });
    }, 2000);
  }

  validateForm() {
    this.validateFormDataService.validateAllFormFields(this.userFields);
    if (this.userFields.valid) {
      this.isChildFormValid.emit(true);
    } else {
      this.isChildFormValid.emit(false);
    }
  }

  setUserFields() {
    this.userFields.controls.inCareWhenExcluded.reset();
    this.userFields.controls.pastoralRecd.reset();

    if (!this.isNullOrEmpty(this.exclusion.startDate)) {
      this.userFields.controls.startDate.setValue(
        new Date(this.exclusion.startDate)
      );
    }
    if (!this.isNullOrEmpty(this.exclusion.endDate)) {
      this.userFields.controls.endDate.setValue(
        new Date(this.exclusion.endDate)
      );
    }
    this.userFields.controls.startTime.setValue(this.exclusion.startTime);
    this.userFields.controls.endTime.setValue(this.exclusion.endTime);
    this.userFields.controls.senStageWhenExcluded.setValue(
      this.exclusion.senStageWhenExcluded
    );
    if (
      !this.isNullOrEmpty(this.exclusion.inCareWhenExcluded) &&
      new String(this.exclusion.inCareWhenExcluded).toLowerCase() ==
        this.TRUE_VALUE
    ) {
      this.userFields.controls.inCareWhenExcluded.setValue(true);
    }
    if (
      !this.isNullOrEmpty(this.exclusion.pastoralRecd) &&
      new String(this.exclusion.pastoralRecd).toLowerCase() == this.TRUE_VALUE
    ) {
      this.userFields.controls.pastoralRecd.setValue(true);
    }
    if (!this.isNullOrEmpty(this.exclusion.endMonitorDate)) {
      this.userFields.controls.endMonitorDate.setValue(
        new Date(this.exclusion.endMonitorDate)
      );
    }
    if (!this.isNullOrEmpty(this.exclusion.sixthDay)) {
      this.userFields.controls.sixthDay.setValue(
        new Date(this.exclusion.sixthDay)
      );
    }
    if (this.isReinstateCategory()) {
      if (!this.isNullOrEmpty(this.exclusion.reinstatedWithdrawnReasonDate)) {
        this.userFields.controls.reinstateDate.setValue(
          new Date(this.exclusion.reinstatedWithdrawnReasonDate)
        );
      }
      if (!this.isNullOrEmpty(this.exclusion.reinstatedWithdrawnReason)) {
        this.userFields.controls.reinstateReason.setValue(
          this.exclusion.reinstatedWithdrawnReason
        );
      }
    }
    if (
      this.isWithdrawnCategory() &&
      this.exclusion.reinstatedWithdrawnReasonDate != null
    ) {
      this.userFields.controls.withdrawnDate.setValue(
        new Date(this.exclusion.reinstatedWithdrawnReasonDate)
      );
      this.userFields.controls.withdrawnReason.setValue(
        this.exclusion.reinstatedWithdrawnReason
      );
    }
    if (!this.isNullOrEmpty(this.exclusion.dateOffRoll)) {
      this.userFields.controls.dateOffRoll.setValue(
        new Date(this.exclusion.dateOffRoll)
      );
    }
    this.excludedDays = this.exclusion.excludedDays;
    this.userFields.controls.excludedDays.setValue(this.exclusion.excludedDays);

    this.userFields.controls.excludedLunchTimes.setValue(
      this.exclusion.excludedLunchTimes
    );
    this.userFields.controls.excludedDaysOffset.setValue(
      this.exclusion.excludedDaysOffset
    );
    this.userFields.controls.lengthToDate.setValue(
      this.exclusion.excludedDaysToDate
    );
  }

  isReinstateCategory() {
    return (
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_PERM ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_FIXED ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_REINSTATE_FROM_SUSP
    );
  }

  isWithdrawnCategory() {
    return (
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_PERM ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_FIX ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_LCH ||
      this.selectedCategoryExternalCode ===
        exclusionCategoryEnum.EXT_CODE_WITHDRAW_FROM_SUSP
    );
  }

  // Update Exclusion status - currently excluded
  // Call the Student Summary API which returns the latest currently excluded value
  private updateExclusionStatus() {
    const apiRoute = this.getStudentSummaryRoute(
      this.pupilData.studentId,
      this.schoolId
    );
    this.apiService.get<any>(apiRoute, '').subscribe({
      next: (x: any) => {
        if (parseInt(x.statusCode) === 200) {
          //Request to refresh Student Summary page is set.  Alert then caught in Student Summary page.
          this.messagingService.sendAlert('refreshSummary');
        }
      },
      error: () => {
        this.notificationService.showError('Error getting student summary');
      }
    });
  }

  getStudentSummaryRoute(studentId: number, schoolId: number) {
    return STUDENT_ENDPOINT.GetStudentSummary.replace(
      '{studentId}',
      studentId.toString()
    ).replace('{schoolId}', schoolId.toString());
  }

  private setFocusOnEditExclusionDetailsButton() {
    setTimeout(() => {
      if (
        this.buttonExclusionDetails &&
        this.isSetFocusOnEditExclusionsButton
      ) {
        this.buttonExclusionDetails.nativeElement.focus();
        this.isSetFocusOnEditExclusionsButton = false;
      }
    }, 0);
  }

  resetData() {
    //Reset Data method is required in Unsaved changes template
  }

  canDeactivate() {
    return this.dataLossService.isDirty();
  }

  // Ensures all page content is contained by landmarks
  private setLandmarkRoleForDropdowns() {
    if (this.dropdownCategory) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.dropdownCategory
      );
    }
    if (this.dropdownStartTime) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.dropdownStartTime
      );
    }
    if (this.dropdownEndTime) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.dropdownEndTime
      );
    }
    if (this.senStatusDropdown) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.senStatusDropdown
      );
    }
    if (this.reinstateReasonDropdown) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.reinstateReasonDropdown
      );
    }
    if (this.withdrawnReasonDropdown) {
      this.accessibilityService.setLandmarkRoleForDropDown(
        this.withdrawnReasonDropdown
      );
    }
  }

  // Ensure elements that have scrollable content are accessible by keyboard
  private setTabindexInScrollableRegionForDropDowns() {
    if (this.dropdownCategory) {
      this.accessibilityService.setTabindexInScrollableRegionForDropdDown(
        this.dropdownCategory
      );
    }
    if (this.senStatusDropdown) {
      this.accessibilityService.setTabindexInScrollableRegionForDropdDown(
        this.senStatusDropdown
      );
    }
  }
  // Ensures role attribute has an appropriate value for the element
  private removeRoleAttributeForDropDowns() {
    if (this.dropdownCategory) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.dropdownCategory
      );
    }
    if (this.dropdownStartTime) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.dropdownStartTime
      );
    }
    if (this.dropdownEndTime) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.dropdownEndTime
      );
    }
    if (this.senStatusDropdown) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.senStatusDropdown
      );
    }
    if (this.reinstateReasonDropdown) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.reinstateReasonDropdown
      );
    }
    if (this.withdrawnReasonDropdown) {
      this.accessibilityService.removeRoleAttributeForDropDown(
        this.withdrawnReasonDropdown
      );
    }
  }

  // End monitoring date validations depend on the Start Date/End Date
  private validateEndMonitoringDateOnStartAndEndDate() {
    let endMonitoringDate = '';
    // If the latest end monitoring date is entered use it else
    // use the control value
    if (this.enteredEndMonitoringDate) {
      endMonitoringDate = this.enteredEndMonitoringDate;
    } else if (
      !this.isNullOrEmpty(this.userFields.controls.endMonitorDate.value)
    ) {
      endMonitoringDate = this.datePipe.transform(
        this.userFields.controls.endMonitorDate.value,
        this.dateInputFormat
      );
    }

    this.validateEndMonitoringDate(endMonitoringDate);
  }
}
